export const marketing_zhCN = {
  'marketing.menu': `营销活动`,
  'marketing.scene.menu': `场景营销`,
  'marketing.scene.holiday.menu': `节日营销`,
  'marketing.scene.reg.menu': `会员注册营销`,
  'marketing.scene.birth.menu': `生日营销`,
  'marketing.scene.memberday.menu': `会员日营销`,
  'marketing.scene.binding.menu': `会员绑定`,
  'marketing.scene.consume.menu': `会员消费`,
  'marketing.scene.rank.menu': `等级变更`,
  'marketing.scene.data.menu': `活动数据`,
  'marketing.scene.points.menu': `积分使用`,
  'marketing.people.menu': `人群运营`,
  'marketing.people.regnotcon.menu': `注册未支付用户`,
  'marketing.people.imprecall.menu': `需重点召回用户`,
  'marketing.people.custom.menu': `自定义人群`,
  'marketing.people.mpnumber.menu': `指定手机号用户`,
  'marketing.event.menu': `活动运营`,
  'marketing.scene.n01.lbl01': `节日营销`,
  'marketing.scene.n01.lbl02': `烘托节日氛围 会员专享权益`,
  'marketing.scene.n01.lbl03': `提升店铺营销额`,
  'marketing.scene.n02.lbl01': `会员注册营销`,
  'marketing.scene.n02.lbl02': `吸引客户成为会员`,
  'marketing.scene.n02.lbl03': `提高会员拉新`,
  'marketing.scene.n03.lbl01': `生日营销`,
  'marketing.scene.n03.lbl02': `特定时间会员专属优惠`,
  'marketing.scene.n03.lbl03': `提高店铺销量和复购`,
  'marketing.scene.n04.lbl01': `会员日营销`,
  'marketing.scene.n04.lbl02': `会员生日月特别活动`,
  'marketing.scene.n04.lbl03': `提高客户黏性`,
  'marketing.scene.n05.lbl01': `会员绑定`,
  'marketing.scene.n05.lbl02': `会员生日月特别活动`,
  'marketing.scene.n05.lbl03': `提高客户黏性`,
  'marketing.scene.n06.lbl01': `会员消费`,
  'marketing.scene.n06.lbl02': `会员生日月特别活动`,
  'marketing.scene.n06.lbl03': `提高客户黏性`,
  'marketing.scene.n07.lbl01': `等级变更`,
  'marketing.scene.n07.lbl02': `会员生日月特别活动`,
  'marketing.scene.n07.lbl03': `提高客户黏性`,
  'marketing.scene.n08.lbl01': `积分使用`,
  'marketing.scene.n08.lbl02': `会员生日月特别活动`,
  'marketing.scene.n08.lbl03': `提高客户黏性`,
  'marketing.scene.n09.lbl01': `名称`,
  'marketing.scene.n09.rdo02': `类型`,
  'marketing.scene.n09.rdo03': `状态`,
  'marketing.scene.c01.lbl01': `活动名称`,
  'marketing.scene.c01.txt01': `活动名称为必填项`,
  'marketing.scene.c01.txt02': `请选择时间`,
  'marketing.scene.c01.txt03': `请选择月份`,
  'marketing.scene.c01.txt04': `请选择日期`,
  'marketing.scene.c01.txt05': `请选择开始日期`,
  'marketing.scene.c01.txt06': `请选择结束日期`,
  'marketing.scene.c01.txt07': `开始日期不得大于结束日期`,
  'marketing.scene.c01.lbl02': `类型`,
  'marketing.scene.c01.lbl03': `活动时间`,
  'marketing.scene.c01.lbl04': `会员范围`,
  'marketing.scene.c01.lbl05': `状态`,
  'marketing.scene.c01.lbl06': `操作`,
  'marketing.scene.n10.lbl01': `名称`,
  'marketing.scene.n10.lbl02': `类型`,
  'marketing.scene.n10.lbl03': `状态`,
  'marketing.scene.holiday.n01.lbl01': `基本设置`,
  'marketing.scene.holiday.n01.lbl02': `活动名称`,
  'marketing.scene.holiday.n01.lbl03': `活动时间`,
  'marketing.scene.holiday.n01.rdo04': `开始日期`,
  'marketing.scene.holiday.n01.lbl05': `至`,
  'marketing.scene.holiday.n01.rdo06': `结束日期`,
  'marketing.scene.holiday.n02.lbl01': `活动权益`,
  'marketing.scene.holiday.n02.chb02': `会员等级规则`,
  'marketing.scene.holiday.n02.rdo03': `所有会员等级，相同规则`,
  'marketing.scene.holiday.c01.lbl01': `会员等级`,
  'marketing.scene.holiday.c01.lbl02': `消费折扣`,
  'marketing.scene.holiday.c01.lbl03': `积分回馈`,
  'marketing.scene.holiday.c01.lbl04': `送积分`,
  'marketing.scene.holiday.c01.lbl05': `送优惠券`,
  'marketing.scene.holiday.c01.lbl06': `状态`,
  'marketing.scene.holiday.c02.txt01': `设置`,
  'marketing.scene.holiday.c02.txt02': `修改`,
  'marketing.scene.holiday.c02.txt03': `开启`,
  'marketing.scene.holiday.c02.txt04': `关闭`,
  'marketing.scene.holiday.n03.rdo01': `不同会员等级，不同规则`,
  'marketing.scene.holiday.c02.lbl01': `会员等级`,
  'marketing.scene.holiday.c02.lbl02': `消费折扣`,
  'marketing.scene.holiday.c02.lbl03': `积分回馈`,
  'marketing.scene.holiday.c02.lbl04': `送积分`,
  'marketing.scene.holiday.c02.lbl05': `送优惠券`,
  'marketing.scene.holiday.c02.lbl06': `状态`,
  'marketing.scene.holiday.c02.lbl07': `初履会员`,
  'marketing.scene.holiday.c02.lbl08': `心履会员`,
  'marketing.scene.holiday.c02.lbl09': `优履会员`,
  'marketing.scene.holiday.c02.lbl10': `奢履会员`,
  'marketing.scene.holiday.n04.lbl01': `限制首单`,
  'marketing.scene.holiday.n04.rdo02': `消费折扣、积分回馈和送积分适用于所有订单`,
  'marketing.scene.holiday.n04.rdo03': `消费折扣、积分回馈和送积分适用于第一笔订单`,
  'marketing.scene.holiday.n04.chb04': `商品规则`,
  'marketing.scene.holiday.n04.rdo05': `订单中含指定商品，仅指定商品可获得权益`,
  'marketing.scene.holiday.n04.rdo06': `订单中含指定商品，整单可获得权益`,
  'marketing.scene.holiday.n05.btn01': `添加`,
  'marketing.scene.holiday.d01.placeholder01': `请输入优惠券名称`,
  'marketing.scene.holiday.d01.lbl02': `选择优惠券`,
  'marketing.scene.holiday.d01.lbl03': `优惠券名称`,
  'marketing.scene.holiday.d01.lbl04': `适用商品`,
  'marketing.scene.holiday.d01.lbl05': `优惠内容`,
  'marketing.scene.holiday.d01.lbl06': `领取人限制`,
  'marketing.scene.holiday.d01.lbl07': `限领次数`,
  'marketing.scene.holiday.d01.lbl08': `剩余库存`,
  'marketing.scene.holiday.d02.lbl01': `款号`,
  'marketing.scene.holiday.d02.lbl02': `货号`,
  'marketing.scene.holiday.d02.lbl03': `SKU`,
  'marketing.scene.holiday.d02.lbl04': `系列`,
  'marketing.scene.holiday.d02.lbl05': `全球季节`,
  'marketing.scene.holiday.d02.lbl06': `品类`,
  'marketing.scene.holiday.d02.lbl07': `大类`,
  'marketing.scene.holiday.n06.lbl01': `款号`,
  'marketing.scene.holiday.n06.lbl02': `货号`,
  'marketing.scene.holiday.n06.lbl03': `SKU`,
  'marketing.scene.holiday.n06.lbl04': `系列`,
  'marketing.scene.holiday.n06.lbl05': `全球季节`,
  'marketing.scene.holiday.n06.lbl06': `品类`,
  'marketing.scene.holiday.n06.lbl07': `大类`,
  'marketing.scene.holiday.c03.lbl01': `编码`,
  'marketing.scene.holiday.c03.lbl02': `名称`,
  'marketing.scene.holiday.c03.lbl03': `消费折扣`,
  'marketing.scene.holiday.c03.lbl04': `积分回馈`,
  'marketing.scene.holiday.c03.lbl05': `送积分`,
  'marketing.scene.holiday.c03.lbl06': `送优惠券`,
  'marketing.scene.holiday.c03.lbl07': `操作`,
  'marketing.scene.holiday.c04.lbl01': `编码`,
  'marketing.scene.holiday.c04.lbl02': `名称`,
  'marketing.scene.holiday.c04.lbl03': `消费折扣`,
  'marketing.scene.holiday.c04.lbl04': `积分回馈`,
  'marketing.scene.holiday.c04.lbl05': `送积分`,
  'marketing.scene.holiday.c04.lbl06': `送优惠券`,
  'marketing.scene.holiday.c04.lbl07': `操作`,
  'marketing.scene.holiday.c05.lbl01': `SKU`,
  'marketing.scene.holiday.c05.lbl02': `内容`,
  'marketing.scene.holiday.c05.lbl03': `消费折扣`,
  'marketing.scene.holiday.c05.lbl04': `积分回馈`,
  'marketing.scene.holiday.c05.lbl05': `送积分`,
  'marketing.scene.holiday.c05.lbl06': `送优惠券`,
  'marketing.scene.holiday.c05.lbl07': `操作`,
  'marketing.scene.holiday.c06.lbl01': `编码`,
  'marketing.scene.holiday.c06.lbl02': `名称`,
  'marketing.scene.holiday.c06.lbl03': `消费折扣`,
  'marketing.scene.holiday.c06.lbl04': `积分回馈`,
  'marketing.scene.holiday.c06.lbl05': `送积分`,
  'marketing.scene.holiday.c06.lbl06': `送优惠券`,
  'marketing.scene.holiday.c06.lbl07': `操作`,
  'marketing.scene.holiday.c07.lbl01': `编码`,
  'marketing.scene.holiday.c07.lbl02': `名称`,
  'marketing.scene.holiday.c07.lbl03': `消费折扣`,
  'marketing.scene.holiday.c07.lbl04': `积分回馈`,
  'marketing.scene.holiday.c07.lbl05': `送积分`,
  'marketing.scene.holiday.c07.lbl06': `送优惠券`,
  'marketing.scene.holiday.c07.lbl07': `操作`,
  'marketing.scene.holiday.c08.lbl01': `编码`,
  'marketing.scene.holiday.c08.lbl02': `名称`,
  'marketing.scene.holiday.c08.lbl03': `消费折扣`,
  'marketing.scene.holiday.c08.lbl04': `积分回馈`,
  'marketing.scene.holiday.c08.lbl05': `送积分`,
  'marketing.scene.holiday.c08.lbl06': `送优惠券`,
  'marketing.scene.holiday.c08.lbl07': `操作`,
  'marketing.scene.holiday.c09.lbl01': `编码`,
  'marketing.scene.holiday.c09.lbl02': `名称`,
  'marketing.scene.holiday.c09.lbl03': `消费折扣`,
  'marketing.scene.holiday.c09.lbl04': `积分回馈`,
  'marketing.scene.holiday.c09.lbl05': `送积分`,
  'marketing.scene.holiday.c09.lbl06': `送优惠券`,
  'marketing.scene.holiday.c09.lbl07': `操作`,
  'marketing.scene.holiday.n07.lbl01': `公司规则`,
  'marketing.scene.holiday.n07.rdo02': `全部公司`,
  'marketing.scene.holiday.n07.rdo03': `指定公司`,
  'marketing.scene.holiday.n07.rdo04': `公司名称`,
  'marketing.scene.holiday.n08.lbl01': `门店规则`,
  'marketing.scene.holiday.n08.rdo02': `全部门店`,
  'marketing.scene.holiday.n08.rdo03': `仅正价店`,
  'marketing.scene.holiday.n08.rdo04': `指定门店`,
  'marketing.scene.holiday.n09.lbl01': `通知配置`,
  'marketing.scene.holiday.n09.lbl02': `通知渠道`,
  'marketing.scene.holiday.n09.chb03': `短信通知`,
  'marketing.scene.holiday.n09.rdo04': `选择消息`,
  'marketing.scene.holiday.n09.chb05': `微信模板消息`,
  'marketing.scene.holiday.n09.rdo06': `选择消息`,
  'marketing.scene.holiday.n10.lbl01': `通知规则`,
  'marketing.scene.holiday.n10.rdo02': `仅通知一个渠道`,
  'marketing.scene.holiday.c10.lbl01': `通知优先级`,
  'marketing.scene.holiday.c10.lbl02': `通知渠道`,
  'marketing.scene.holiday.c10.lbl03': `1`,
  'marketing.scene.holiday.c10.lbl04': `微信模板消息`,
  'marketing.scene.holiday.c10.lbl05': `2`,
  'marketing.scene.holiday.c10.lbl06': `短信`,
  'marketing.scene.holiday.n11.rdo01': `所有渠道同步通知`,
  'marketing.scene.holiday.n11.txt02': `同一个客户，多个渠道通知，有可能会骚扰客户，请谨慎使用`,
  'marketing.scene.reg.n01.lbl01': `基本设置`,
  'marketing.scene.reg.n01.lbl02': `活动名称`,
  'marketing.scene.reg.n02.lbl01': `活动权益`,
  'marketing.scene.reg.n02.chb02': `会员等级规则`,
  'marketing.scene.reg.c01.lbl01': `会员等级`,
  'marketing.scene.reg.c01.lbl02': `消费折扣`,
  'marketing.scene.reg.c01.lbl03': `积分回馈`,
  'marketing.scene.reg.c01.lbl04': `送积分`,
  'marketing.scene.reg.c01.lbl05': `送优惠券`,
  'marketing.scene.reg.c01.lbl06': `状态`,
  'marketing.scene.reg.d01.placeholder01': `请输入优惠券名称`,
  'marketing.scene.reg.d01.lbl02': `选择优惠券`,
  'marketing.scene.reg.d01.lbl03': `优惠券名称`,
  'marketing.scene.reg.d01.lbl04': `适用商品`,
  'marketing.scene.reg.d01.lbl05': `优惠内容`,
  'marketing.scene.reg.d01.lbl06': `领取人限制`,
  'marketing.scene.reg.d01.lbl07': `限领次数`,
  'marketing.scene.reg.d01.lbl08': `剩余库存`,
  'marketing.scene.reg.n03.lbl01': `通知配置`,
  'marketing.scene.reg.n03.lbl02': `通知渠道`,
  'marketing.scene.reg.n03.chb03': `短信通知`,
  'marketing.scene.reg.n03.rdo04': `选择消息`,
  'marketing.scene.reg.n03.chb05': `微信模板消息`,
  'marketing.scene.reg.n03.rdo06': `选择消息`,
  'marketing.scene.reg.n04.lbl01': `通知规则`,
  'marketing.scene.reg.n04.rdo02': `仅通知一个渠道`,
  'marketing.scene.reg.c02.lbl01': `通知优先级`,
  'marketing.scene.reg.c02.lbl02': `通知渠道`,
  'marketing.scene.reg.c02.lbl03': `1`,
  'marketing.scene.reg.c02.lbl04': `微信模板消息`,
  'marketing.scene.reg.c02.lbl05': `2`,
  'marketing.scene.reg.c02.lbl06': `短信`,
  'marketing.scene.reg.n05.rdo01': `所有渠道同步通知`,
  'marketing.scene.reg.n05.txt02': `同一个客户，多个渠道通知，有可能会骚扰客户，请谨慎使用`,
  'marketing.scene.birth.n01.lbl01': `基本设置`,
  'marketing.scene.birth.n01.lbl02': `活动名称`,
  'marketing.scene.birth.n01.lbl03': `活动周期`,
  'marketing.scene.birth.n01.rdo04': `生日当天发放`,
  'marketing.scene.birth.n01.rdo05': `生日当月发放`,
  'marketing.scene.birth.n01.rdo06': `发放`,
  'marketing.scene.birth.n01.chb06': `注册当月为生日月，则当月不发放`,
  'marketing.scene.birth.n02.lbl01': `活动权益`,
  'marketing.scene.birth.n02.chb02': `会员等级规则`,
  'marketing.scene.birth.n02.rdo03': `所有会员等级，相同规则`,
  'marketing.scene.birth.c01.lbl01': `会员等级`,
  'marketing.scene.birth.c01.lbl02': `消费折扣`,
  'marketing.scene.birth.c01.lbl03': `积分回馈`,
  'marketing.scene.birth.c01.lbl04': `送积分`,
  'marketing.scene.birth.c01.lbl05': `送优惠券`,
  'marketing.scene.birth.c01.lbl06': `状态`,
  'marketing.scene.birth.d01.placeholder01': `请输入优惠券名称`,
  'marketing.scene.birth.d01.lbl02': `选择优惠券`,
  'marketing.scene.birth.d01.lbl03': `优惠券名称`,
  'marketing.scene.birth.d01.lbl04': `适用商品`,
  'marketing.scene.birth.d01.lbl05': `优惠内容`,
  'marketing.scene.birth.d01.lbl06': `领取人限制`,
  'marketing.scene.birth.d01.lbl07': `限领次数`,
  'marketing.scene.birth.d01.lbl08': `剩余库存`,
  'marketing.scene.birth.n03.rdo01': `不同会员等级，不同规则`,
  'marketing.scene.birth.c02.lbl01': `会员等级`,
  'marketing.scene.birth.c02.lbl02': `消费折扣`,
  'marketing.scene.birth.c02.lbl03': `积分回馈`,
  'marketing.scene.birth.c02.lbl04': `送积分`,
  'marketing.scene.birth.c02.lbl05': `送优惠券`,
  'marketing.scene.birth.c02.lbl06': `状态`,
  'marketing.scene.birth.c02.lbl07': `初履会员`,
  'marketing.scene.birth.c02.lbl08': `心履会员`,
  'marketing.scene.birth.c02.lbl09': `优履会员`,
  'marketing.scene.birth.c02.lbl10': `奢履会员`,
  'marketing.scene.birth.n04.lbl01': `限制首单`,
  'marketing.scene.birth.n04.rdo02': `消费折扣、积分回馈和送积分适用于所有订单`,
  'marketing.scene.birth.n04.rdo03': `消费折扣、积分回馈和送积分适用于第一笔订单`,
  'marketing.scene.birth.n05.lbl01': `通知配置`,
  'marketing.scene.birth.n05.lbl02': `通知渠道`,
  'marketing.scene.birth.n05.chb03': `短信通知`,
  'marketing.scene.birth.n05.rdo04': `选择消息`,
  'marketing.scene.birth.n05.chb05': `微信模板消息`,
  'marketing.scene.birth.n05.rdo06': `选择消息`,
  'marketing.scene.birth.n06.lbl01': `通知规则`,
  'marketing.scene.birth.n06.rdo02': `仅通知一个渠道`,
  'marketing.scene.birth.c03.lbl01': `通知优先级`,
  'marketing.scene.birth.c03.lbl02': `通知渠道`,
  'marketing.scene.birth.c03.lbl03': `1`,
  'marketing.scene.birth.c03.lbl04': `微信模板消息`,
  'marketing.scene.birth.c03.lbl05': `2`,
  'marketing.scene.birth.c03.lbl06': `短信`,
  'marketing.scene.birth.n07.rdo01': `所有渠道同步通知`,
  'marketing.scene.birth.n07.txt02': `同一个客户，多个渠道通知，有可能会骚扰客户，请谨慎使用`,
  'marketing.scene.memberday.n01.lbl01': `基本设置`,
  'marketing.scene.memberday.n01.lbl02': `活动名称`,
  'marketing.scene.memberday.n01.lbl03': `活动周期`,
  'marketing.scene.memberday.n01.rdo04': `每年`,
  'marketing.scene.memberday.n01.rdo05': `至`,
  'marketing.scene.memberday.n01.rdo06': `每年指定日期`,
  'marketing.scene.memberday.n02.lbl01': `活动权益`,
  'marketing.scene.memberday.n02.chb02': `会员等级规则`,
  'marketing.scene.memberday.n02.rdo03': `所有会员等级，相同规则`,
  'marketing.scene.memberday.c01.lbl01': `会员等级`,
  'marketing.scene.memberday.c01.lbl02': `消费折扣`,
  'marketing.scene.memberday.c01.lbl03': `积分回馈`,
  'marketing.scene.memberday.c01.lbl04': `送积分`,
  'marketing.scene.memberday.c01.lbl05': `送优惠券`,
  'marketing.scene.memberday.c01.lbl06': `状态`,
  'marketing.scene.memberday.d01.placeholder01': `请输入优惠券名称`,
  'marketing.scene.memberday.d01.lbl02': `选择优惠券`,
  'marketing.scene.memberday.d01.lbl03': `优惠券名称`,
  'marketing.scene.memberday.d01.lbl04': `适用商品`,
  'marketing.scene.memberday.d01.lbl05': `优惠内容`,
  'marketing.scene.memberday.d01.lbl06': `领取人限制`,
  'marketing.scene.memberday.d01.lbl07': `限领次数`,
  'marketing.scene.memberday.d01.lbl08': `剩余库存`,
  'marketing.scene.memberday.n03.rdo01': `不同会员等级，不同规则`,
  'marketing.scene.memberday.c02.lbl01': `会员等级`,
  'marketing.scene.memberday.c02.lbl02': `消费折扣`,
  'marketing.scene.memberday.c02.lbl03': `积分回馈`,
  'marketing.scene.memberday.c02.lbl04': `送积分`,
  'marketing.scene.memberday.c02.lbl05': `送优惠券`,
  'marketing.scene.memberday.c02.lbl06': `状态`,
  'marketing.scene.memberday.c02.lbl07': `初履会员`,
  'marketing.scene.memberday.c02.lbl08': `心履会员`,
  'marketing.scene.memberday.c02.lbl09': `优履会员`,
  'marketing.scene.memberday.c02.lbl10': `奢履会员`,
  'marketing.scene.memberday.n04.lbl01': `限制首单`,
  'marketing.scene.memberday.n04.rdo02': `消费折扣、积分回馈和送积分适用于所有订单`,
  'marketing.scene.memberday.n04.rdo03': `消费折扣、积分回馈和送积分适用于第一笔订单`,
  'marketing.scene.memberday.n05.lbl01': `门店规则`,
  'marketing.scene.memberday.n05.rdo02': `全部门店`,
  'marketing.scene.memberday.n05.rdo03': `仅正价店`,
  'marketing.scene.memberday.n05.rdo04': `指定门店`,
  'marketing.scene.memberday.n06.lbl01': `通知配置`,
  'marketing.scene.memberday.n06.lbl02': `通知渠道`,
  'marketing.scene.memberday.n06.chb03': `短信通知`,
  'marketing.scene.memberday.n06.rdo04': `选择消息`,
  'marketing.scene.memberday.n06.chb05': `微信模板消息`,
  'marketing.scene.memberday.n06.rdo06': `选择消息`,
  'marketing.scene.memberday.n07.lbl01': `通知规则`,
  'marketing.scene.memberday.n07.rdo02': `仅通知一个渠道`,
  'marketing.scene.memberday.c03.lbl01': `通知优先级`,
  'marketing.scene.memberday.c03.lbl02': `通知渠道`,
  'marketing.scene.memberday.c03.lbl03': `1`,
  'marketing.scene.memberday.c03.lbl04': `微信模板消息`,
  'marketing.scene.memberday.c03.lbl05': `2`,
  'marketing.scene.memberday.c03.lbl06': `短信`,
  'marketing.scene.memberday.n08.rdo01': `所有渠道同步通知`,
  'marketing.scene.memberday.n08.txt02': `同一个客户，多个渠道通知，有可能会骚扰客户，请谨慎使用`,
  'marketing.scene.binding.n01.lbl01': `基本设置`,
  'marketing.scene.binding.n01.lbl02': `活动名称`,
  'marketing.scene.binding.n02.lbl01': `活动权益`,
  'marketing.scene.binding.n02.chb02': `会员等级规则`,
  'marketing.scene.binding.n02.rdo03': `所有会员等级，相同规则`,
  'marketing.scene.binding.c01.lbl01': `会员等级`,
  'marketing.scene.binding.c01.lbl02': `消费折扣`,
  'marketing.scene.binding.c01.lbl03': `积分回馈`,
  'marketing.scene.binding.c01.lbl04': `送积分`,
  'marketing.scene.binding.c01.lbl05': `送优惠券`,
  'marketing.scene.binding.c01.lbl06': `状态`,
  'marketing.scene.binding.d01.placeholder01': `请输入优惠券名称`,
  'marketing.scene.binding.d01.lbl02': `选择优惠券`,
  'marketing.scene.binding.d01.lbl03': `优惠券名称`,
  'marketing.scene.binding.d01.lbl04': `适用商品`,
  'marketing.scene.binding.d01.lbl05': `优惠内容`,
  'marketing.scene.binding.d01.lbl06': `领取人限制`,
  'marketing.scene.binding.d01.lbl07': `限领次数`,
  'marketing.scene.binding.d01.lbl08': `剩余库存`,
  'marketing.scene.binding.n03.rdo01': `不同会员等级，不同规则`,
  'marketing.scene.binding.c02.lbl01': `会员等级`,
  'marketing.scene.binding.c02.lbl02': `消费折扣`,
  'marketing.scene.binding.c02.lbl03': `积分回馈`,
  'marketing.scene.binding.c02.lbl04': `送积分`,
  'marketing.scene.binding.c02.lbl05': `送优惠券`,
  'marketing.scene.binding.c02.lbl06': `状态`,
  'marketing.scene.binding.c02.lbl07': `初履会员`,
  'marketing.scene.binding.c02.lbl08': `心履会员`,
  'marketing.scene.binding.c02.lbl09': `优履会员`,
  'marketing.scene.binding.c02.lbl10': `奢履会员`,
  'marketing.scene.binding.n04.lbl01': `限制首单`,
  'marketing.scene.binding.n04.rdo02': `消费折扣、积分回馈和送积分适用于所有订单`,
  'marketing.scene.binding.n04.rdo03': `消费折扣、积分回馈和送积分适用于第一笔订单`,
  'marketing.scene.binding.n05.lbl01': `通知配置`,
  'marketing.scene.binding.n05.lbl02': `通知渠道`,
  'marketing.scene.binding.n05.chb03': `短信通知`,
  'marketing.scene.binding.n05.rdo04': `选择消息`,
  'marketing.scene.binding.n05.chb05': `微信模板消息`,
  'marketing.scene.binding.n05.rdo06': `选择消息`,
  'marketing.scene.binding.n06.lbl01': `通知规则`,
  'marketing.scene.binding.n06.rdo02': `仅通知一个渠道`,
  'marketing.scene.binding.c03.lbl01': `通知优先级`,
  'marketing.scene.binding.c03.lbl02': `通知渠道`,
  'marketing.scene.binding.c03.lbl03': `1`,
  'marketing.scene.binding.c03.lbl04': `微信模板消息`,
  'marketing.scene.binding.c03.lbl05': `2`,
  'marketing.scene.binding.c03.lbl06': `短信`,
  'marketing.scene.binding.n07.rdo01': `所有渠道同步通知`,
  'marketing.scene.binding.n07.txt02': `同一个客户，多个渠道通知，有可能会骚扰客户，请谨慎使用`,
  'marketing.scene.consume.n01.lbl01': `基本设置`,
  'marketing.scene.consume.n01.lbl02': `活动名称`,
  'marketing.scene.consume.n02.lbl01': `活动权益`,
  'marketing.scene.consume.n02.chb02': `会员等级规则`,
  'marketing.scene.consume.n02.rdo03': `所有会员等级，相同规则`,
  'marketing.scene.consume.c01.lbl01': `会员等级`,
  'marketing.scene.consume.c01.lbl02': `消费折扣`,
  'marketing.scene.consume.c01.lbl03': `积分回馈`,
  'marketing.scene.consume.c01.lbl04': `送积分`,
  'marketing.scene.consume.c01.lbl05': `送优惠券`,
  'marketing.scene.consume.c01.lbl06': `状态`,
  'marketing.scene.consume.d01.placeholder01': `请输入优惠券名称`,
  'marketing.scene.consume.d01.lbl02': `选择优惠券`,
  'marketing.scene.consume.d01.lbl03': `优惠券名称`,
  'marketing.scene.consume.d01.lbl04': `适用商品`,
  'marketing.scene.consume.d01.lbl05': `优惠内容`,
  'marketing.scene.consume.d01.lbl06': `领取人限制`,
  'marketing.scene.consume.d01.lbl07': `限领次数`,
  'marketing.scene.consume.d01.lbl08': `剩余库存`,
  'marketing.scene.consume.n03.rdo01': `不同会员等级，不同规则`,
  'marketing.scene.consume.c02.lbl01': `会员等级`,
  'marketing.scene.consume.c02.lbl02': `消费折扣`,
  'marketing.scene.consume.c02.lbl03': `积分回馈`,
  'marketing.scene.consume.c02.lbl04': `送积分`,
  'marketing.scene.consume.c02.lbl05': `送优惠券`,
  'marketing.scene.consume.c02.lbl06': `状态`,
  'marketing.scene.consume.c02.lbl07': `初履会员`,
  'marketing.scene.consume.c02.lbl08': `心履会员`,
  'marketing.scene.consume.c02.lbl09': `优履会员`,
  'marketing.scene.consume.c02.lbl10': `奢履会员`,
  'marketing.scene.consume.n04.lbl01': `限制首单`,
  'marketing.scene.consume.n04.rdo02': `消费折扣、积分回馈和送积分适用于所有订单`,
  'marketing.scene.consume.n04.rdo03': `消费折扣、积分回馈和送积分适用于第一笔订单`,
  'marketing.scene.consume.n05.lbl01': `通知配置`,
  'marketing.scene.consume.n05.lbl02': `通知渠道`,
  'marketing.scene.consume.n05.chb03': `短信通知`,
  'marketing.scene.consume.n05.rdo04': `选择消息`,
  'marketing.scene.consume.n05.chb05': `微信模板消息`,
  'marketing.scene.consume.n05.rdo06': `选择消息`,
  'marketing.scene.consume.n06.lbl01': `通知规则`,
  'marketing.scene.consume.n06.rdo02': `仅通知一个渠道`,
  'marketing.scene.consume.c03.lbl01': `通知优先级`,
  'marketing.scene.consume.c03.lbl02': `通知渠道`,
  'marketing.scene.consume.c03.lbl03': `1`,
  'marketing.scene.consume.c03.lbl04': `微信模板消息`,
  'marketing.scene.consume.c03.lbl05': `2`,
  'marketing.scene.consume.c03.lbl06': `短信`,
  'marketing.scene.consume.n07.rdo01': `所有渠道同步通知`,
  'marketing.scene.consume.n07.txt02': `同一个客户，多个渠道通知，有可能会骚扰客户，请谨慎使用`,
  'marketing.scene.rank.n01.lbl01': `基本设置`,
  'marketing.scene.rank.n01.lbl02': `活动名称`,
  'marketing.scene.rank.n02.lbl01': `活动权益`,
  'marketing.scene.rank.n02.chb02': `会员等级规则`,
  'marketing.scene.rank.n02.rdo03': `所有会员等级，相同规则`,
  'marketing.scene.rank.c01.lbl01': `会员等级`,
  'marketing.scene.rank.c01.lbl02': `消费折扣`,
  'marketing.scene.rank.c01.lbl03': `积分回馈`,
  'marketing.scene.rank.c01.lbl04': `送积分`,
  'marketing.scene.rank.c01.lbl05': `送优惠券`,
  'marketing.scene.rank.c01.lbl06': `状态`,
  'marketing.scene.rank.d01.placeholder01': `请输入优惠券名称`,
  'marketing.scene.rank.d01.lbl02': `选择优惠券`,
  'marketing.scene.rank.d01.lbl03': `优惠券名称`,
  'marketing.scene.rank.d01.lbl04': `适用商品`,
  'marketing.scene.rank.d01.lbl05': `优惠内容`,
  'marketing.scene.rank.d01.lbl06': `领取人限制`,
  'marketing.scene.rank.d01.lbl07': `限领次数`,
  'marketing.scene.rank.d01.lbl08': `剩余库存`,
  'marketing.scene.rank.n03.rdo01': `不同会员等级，不同规则`,
  'marketing.scene.rank.c02.lbl01': `会员等级`,
  'marketing.scene.rank.c02.lbl02': `消费折扣`,
  'marketing.scene.rank.c02.lbl03': `积分回馈`,
  'marketing.scene.rank.c02.lbl04': `送积分`,
  'marketing.scene.rank.c02.lbl05': `送优惠券`,
  'marketing.scene.rank.c02.lbl06': `状态`,
  'marketing.scene.rank.c02.lbl07': `初履会员`,
  'marketing.scene.rank.c02.lbl08': `心履会员`,
  'marketing.scene.rank.c02.lbl09': `优履会员`,
  'marketing.scene.rank.c02.lbl10': `奢履会员`,
  'marketing.scene.rank.n04.lbl01': `限制首单`,
  'marketing.scene.rank.n04.rdo02': `消费折扣、积分回馈和送积分适用于所有订单`,
  'marketing.scene.rank.n04.rdo03': `消费折扣、积分回馈和送积分适用于第一笔订单`,
  'marketing.scene.rank.n05.lbl01': `通知配置`,
  'marketing.scene.rank.n05.lbl02': `通知渠道`,
  'marketing.scene.rank.n05.chb03': `短信通知`,
  'marketing.scene.rank.n05.rdo04': `选择消息`,
  'marketing.scene.rank.n05.chb05': `微信模板消息`,
  'marketing.scene.rank.n05.rdo06': `选择消息`,
  'marketing.scene.rank.n06.lbl01': `通知规则`,
  'marketing.scene.rank.n06.rdo02': `仅通知一个渠道`,
  'marketing.scene.rank.c03.lbl01': `通知优先级`,
  'marketing.scene.rank.c03.lbl02': `通知渠道`,
  'marketing.scene.rank.c03.lbl03': `1`,
  'marketing.scene.rank.c03.lbl04': `微信模板消息`,
  'marketing.scene.rank.c03.lbl05': `2`,
  'marketing.scene.rank.c03.lbl06': `短信`,
  'marketing.scene.rank.n07.rdo01': `所有渠道同步通知`,
  'marketing.scene.rank.n07.txt02': `同一个客户，多个渠道通知，有可能会骚扰客户，请谨慎使用`,
  'marketing.scene.points.n01.lbl01': `基本设置`,
  'marketing.scene.points.n01.lbl02': `活动名称`,
  'marketing.scene.points.n02.lbl01': `活动权益`,
  'marketing.scene.points.n02.chb02': `会员等级规则`,
  'marketing.scene.points.n02.rdo03': `所有会员等级，相同规则`,
  'marketing.scene.points.c01.lbl01': `会员等级`,
  'marketing.scene.points.c01.lbl02': `消费折扣`,
  'marketing.scene.points.c01.lbl03': `积分回馈`,
  'marketing.scene.points.c01.lbl04': `送积分`,
  'marketing.scene.points.c01.lbl05': `送优惠券`,
  'marketing.scene.points.c01.lbl06': `状态`,
  'marketing.scene.points.d01.placeholder01': `请输入优惠券名称`,
  'marketing.scene.points.d01.lbl02': `选择优惠券`,
  'marketing.scene.points.d01.lbl03': `优惠券名称`,
  'marketing.scene.points.d01.lbl04': `适用商品`,
  'marketing.scene.points.d01.lbl05': `优惠内容`,
  'marketing.scene.points.d01.lbl06': `领取人限制`,
  'marketing.scene.points.d01.lbl07': `限领次数`,
  'marketing.scene.points.d01.lbl08': `剩余库存`,
  'marketing.scene.points.n03.rdo01': `不同会员等级，不同规则`,
  'marketing.scene.points.c02.lbl01': `会员等级`,
  'marketing.scene.points.c02.lbl02': `消费折扣`,
  'marketing.scene.points.c02.lbl03': `积分回馈`,
  'marketing.scene.points.c02.lbl04': `送积分`,
  'marketing.scene.points.c02.lbl05': `送优惠券`,
  'marketing.scene.points.c02.lbl06': `状态`,
  'marketing.scene.points.c02.lbl07': `初履会员`,
  'marketing.scene.points.c02.lbl08': `心履会员`,
  'marketing.scene.points.c02.lbl09': `优履会员`,
  'marketing.scene.points.c02.lbl10': `奢履会员`,
  'marketing.scene.points.n04.lbl01': `限制首单`,
  'marketing.scene.points.n04.rdo02': `消费折扣、积分回馈和送积分适用于所有订单`,
  'marketing.scene.points.n04.rdo03': `消费折扣、积分回馈和送积分适用于第一笔订单`,
  'marketing.scene.points.n05.lbl01': `通知配置`,
  'marketing.scene.points.n05.lbl02': `通知渠道`,
  'marketing.scene.points.n05.chb03': `短信通知`,
  'marketing.scene.points.n05.rdo04': `选择消息`,
  'marketing.scene.points.n05.chb05': `微信模板消息`,
  'marketing.scene.points.n05.rdo06': `选择消息`,
  'marketing.scene.points.n06.lbl01': `通知规则`,
  'marketing.scene.points.n06.rdo02': `仅通知一个渠道`,
  'marketing.scene.points.c03.lbl01': `通知优先级`,
  'marketing.scene.points.c03.lbl02': `通知渠道`,
  'marketing.scene.points.c03.lbl03': `1`,
  'marketing.scene.points.c03.lbl04': `微信模板消息`,
  'marketing.scene.points.c03.lbl05': `2`,
  'marketing.scene.points.c03.lbl06': `短信`,
  'marketing.scene.points.n07.rdo01': `所有渠道同步通知`,
  'marketing.scene.points.n07.txt02': `同一个客户，多个渠道通知，有可能会骚扰客户，请谨慎使用`,
  'marketing.scene.d01.txt01': `确定要暂停该活动吗`,
  'marketing.scene.d02.txt01': `确定要重启该活动吗`,
  'marketing.scene.d03.txt01': `确定要终止该活动吗`,
  'marketing.scene.d04.txt01': `确定要通过审核吗？`,
  'marketing.scene.c01.tip01': `暂停成功`,
  'marketing.scene.c01.tip02': `终止成功`,
  'marketing.scene.c01.tip03': `审核成功`,
  'marketing.scene.c01.tip04': `重启成功`,
  'marketing.scene.detail.n01.txt01': `待审核`,
  'marketing.scene.detail.n01.txt02': `未开始`,
  'marketing.scene.detail.n01.txt03': `进行中`,
  'marketing.scene.detail.n01.txt04': `已结束`,
  'marketing.scene.detail.n01.txt05': `已暂停`,
  'marketing.people.n01.lbl01': `注册未支付用户`,
  'marketing.people.n01.txt02': `近七天注册成会员`,
  'marketing.people.n01.txt03': `但未进行消费的顾客`,
  'marketing.people.n02.lbl01': `需重点召回用户`,
  'marketing.people.n02.txt02': `历史下单数和客单价`,
  'marketing.people.n02.txt03': `都高于平均 但近90天未下单`,
  'marketing.people.n03.lbl01': `自定义人群`,
  'marketing.people.n03.txt02': `根据自身经营情况`,
  'marketing.people.n03.txt03': `创建个性化的人群运营计划`,
  'marketing.people.n04.lbl01': '指定手机号客户',
  'marketing.people.n04.txt02': '指定手机号',
  'marketing.people.n04.txt03': '定位精确客户',
  'marketing.people.n05.lbl01': `名称`,
  'marketing.people.n05.rdo02': `类型`,
  'marketing.people.n05.rdo03': `状态`,
  'marketing.people.c01.lbl01': `活动名称`,
  'marketing.people.c01.lbl02': `活动类型`,
  'marketing.people.c01.lbl03': `活动时间`,
  'marketing.people.c01.lbl04': `计划方式`,
  'marketing.people.c01.lbl05': `状态`,
  'marketing.people.c01.lbl06': `操作`,
  'marketing.people.n06.lbl01': `名称`,
  'marketing.people.n06.lbl02': `类型`,
  'marketing.people.n06.lbl03': `状态`,
  'marketing.people.d01.txt01': `确定要暂停吗？`,
  'marketing.people.d02.txt01': `确定要重启吗？`,
  'marketing.people.d03.txt01': `确定要终止吗？`,
  'marketing.people.d04.txt01': `确定要审核吗？`,
  'marketing.people.regnotcon.n01.lbl01': `基础信息`,
  'marketing.people.regnotcon.n01.lbl02': `活动名称`,
  'marketing.people.regnotcon.n02.lbl01': `活动人群`,
  'marketing.people.regnotcon.n02.lbl02': `选择人群`,
  'marketing.people.regnotcon.n02.lbl03': `活动名称为必填项`,
  'marketing.people.regnotcon.n02.lbl04': `活动名称的最大长度不得大于20`,
  'marketing.people.regnotcon.n02.lbl05': `活动名称不得为空`,
  'marketing.people.regnotcon.n02.lbl06': `请使用后缀为".csv"文档`,

  'marketing.people.regnotcon.c01.lbl01': `人群`,
  'marketing.people.regnotcon.c01.lbl02': `数量`,
  'marketing.people.regnotcon.n03.lbl01': `活动周期`,
  'marketing.people.regnotcon.n03.rdo02': `单次`,
  'marketing.people.regnotcon.n03.rdo03': `立即执行`,
  'marketing.people.regnotcon.n03.rdo04': `定时执行`,
  'marketing.people.regnotcon.n03.rdo05': `执行时间`,
  'marketing.people.regnotcon.n03.placeholder06': `yyyy/mm/dd hh:mm`,
  'marketing.people.regnotcon.n03.rdo07': `周期性`,
  'marketing.people.regnotcon.n03.rdo09': `每周`,
  'marketing.people.regnotcon.n03.rdo10': `每月`,
  'marketing.people.regnotcon.n03.rdo11': `执行时间`,
  'marketing.people.regnotcon.n03.msg01': `请选择活动日期`,
  'marketing.people.regnotcon.n03.msg02': `请选执行时间`,

  'marketing.people.regnotcon.n04.lbl01': `权益礼包`,
  'marketing.people.regnotcon.n04.lbl02': `优惠券配置`,
  'marketing.people.regnotcon.n04.btn03': `发放优惠券`,
  'marketing.people.regnotcon.n04.lbl04': `发放优惠券能有效刺激转化（优惠券将直接发放给客户，不需要领取）`,
  'marketing.people.regnotcon.d01.placeholder01': `请输入优惠券名称`,
  'marketing.people.regnotcon.d01.lbl02': `选择优惠券`,
  'marketing.people.regnotcon.d01.lbl03': `优惠券名称`,
  'marketing.people.regnotcon.d01.lbl04': `适用商品`,
  'marketing.people.regnotcon.d01.lbl05': `优惠内容`,
  'marketing.people.regnotcon.d01.lbl06': `领取人限制`,
  'marketing.people.regnotcon.d01.lbl07': `限领次数`,
  'marketing.people.regnotcon.d01.lbl08': `剩余库存`,
  'marketing.people.regnotcon.c02.lbl01': `优惠券`,
  'marketing.people.regnotcon.c02.lbl02': `优惠券内容`,
  'marketing.people.regnotcon.c02.lbl03': `库存`,
  'marketing.people.regnotcon.c02.lbl04': `赠券数`,
  'marketing.people.regnotcon.c02.lbl05': `操作`,
  'marketing.people.regnotcon.n05.lbl01': `通知配置`,
  'marketing.people.regnotcon.n05.lbl02': `通知渠道`,
  'marketing.people.regnotcon.n05.chb03': `短信通知`,
  'marketing.people.regnotcon.n05.rdo04': `选择消息`,
  'marketing.people.regnotcon.n05.chb05': `微信模板消息`,
  'marketing.people.regnotcon.n05.rdo06': `选择消息`,
  'marketing.people.regnotcon.n06.lbl01': `通知规则`,
  'marketing.people.regnotcon.n06.rdo02': `仅通知一个渠道`,
  'marketing.people.regnotcon.c03.lbl01': `通知优先级`,
  'marketing.people.regnotcon.c03.lbl02': `通知渠道`,
  'marketing.people.regnotcon.c03.lbl03': `1`,
  'marketing.people.regnotcon.c03.lbl04': `微信模板消息`,
  'marketing.people.regnotcon.c03.lbl05': `2`,
  'marketing.people.regnotcon.c03.lbl06': `短信`,
  'marketing.people.regnotcon.n07.rdo01': `所有渠道同步通知`,
  'marketing.people.regnotcon.n07.txt02': `同一个客户，多个渠道通知，有可能会骚扰客户，请谨慎使用`,
  'marketing.people.custom.d01.lbl01': `选择人群`,
  'marketing.people.custom.d01.placeholder02': `请输入人群名称`,
  'marketing.people.custom.d01.lbl03': `人群名称`,
  'marketing.people.custom.d01.lbl04': `数量`,
  'marketing.people.custom.n02.lbl01': `活动人群`,
  'marketing.people.imprecall.n01.lbl01': `基础信息`,
  'marketing.people.imprecall.n01.lbl02': `活动名称`,
  'marketing.people.imprecall.n02.lbl01': `活动人群`,
  'marketing.people.imprecall.c01.lbl01': `人群`,
  'marketing.people.imprecall.c01.lbl02': `数量`,
  'marketing.people.imprecall.n03.lbl01': `活动周期`,
  'marketing.people.imprecall.n03.rdo02': `单次`,
  'marketing.people.imprecall.n03.rdo03': `立即执行`,
  'marketing.people.imprecall.n03.rdo04': `定时执行`,
  'marketing.people.imprecall.n03.rdo05': `执行时间`,
  'marketing.people.imprecall.n03.placeholder06': `yyyy/mm/dd hh:mm`,
  'marketing.people.imprecall.n03.rdo07': `周期性`,
  'marketing.people.imprecall.n04.lbl01': `权益礼包`,
  'marketing.people.imprecall.n04.lbl02': `优惠券配置`,
  'marketing.people.imprecall.n04.btn03': `发放优惠券`,
  'marketing.people.imprecall.n04.lbl04': `发放优惠券能有效刺激转化（优惠券将直接发放给客户，不需要领取）`,
  'marketing.people.imprecall.d01.placeholder01': `请输入优惠券名称`,
  'marketing.people.imprecall.d01.lbl02': `选择优惠券`,
  'marketing.people.imprecall.d01.lbl03': `优惠券名称`,
  'marketing.people.imprecall.d01.lbl04': `适用商品`,
  'marketing.people.imprecall.d01.lbl05': `优惠内容`,
  'marketing.people.imprecall.d01.lbl06': `领取人限制`,
  'marketing.people.imprecall.d01.lbl07': `限领次数`,
  'marketing.people.imprecall.d01.lbl08': `剩余库存`,
  'marketing.people.imprecall.c02.lbl01': `优惠券`,
  'marketing.people.imprecall.c02.lbl02': `优惠券内容`,
  'marketing.people.imprecall.c02.lbl03': `库存`,
  'marketing.people.imprecall.c02.lbl04': `赠券数`,
  'marketing.people.imprecall.c02.lbl05': `操作`,
  'marketing.people.imprecall.n05.lbl01': `通知配置`,
  'marketing.people.imprecall.n05.lbl02': `通知渠道`,
  'marketing.people.imprecall.n05.chb03': `短信通知`,
  'marketing.people.imprecall.n05.rdo04': `选择消息`,
  'marketing.people.imprecall.n05.chb05': `微信模板消息`,
  'marketing.people.imprecall.n05.rdo06': `选择消息`,
  'marketing.people.imprecall.n06.lbl01': `通知规则`,
  'marketing.people.imprecall.n06.rdo02': `仅通知一个渠道`,
  'marketing.people.imprecall.c03.lbl01': `通知优先级`,
  'marketing.people.imprecall.c03.lbl02': `通知渠道`,
  'marketing.people.imprecall.c03.lbl03': `1`,
  'marketing.people.imprecall.c03.lbl04': `微信模板消息`,
  'marketing.people.imprecall.c03.lbl05': `2`,
  'marketing.people.imprecall.c03.lbl06': `短信`,
  'marketing.people.imprecall.n07.rdo01': `所有渠道同步通知`,
  'marketing.people.imprecall.n07.txt02': `同一个客户，多个渠道通知，有可能会骚扰客户，请谨慎使用`,
  'marketing.people.custom.n01.lbl01': `基础信息`,
  'marketing.people.custom.n01.lbl02': `活动名称`,
  'marketing.people.custom.n01.btn03': `选择人群`,
  'marketing.people.custom.n01.lbl04': `活动人群`,

  'marketing.people.custom.c01.lbl01': `人群`,
  'marketing.people.custom.c01.lbl02': `数量`,
  'marketing.people.custom.n03.lbl01': `活动周期`,
  'marketing.people.custom.n03.rdo02': `单次`,
  'marketing.people.custom.n03.rdo03': `立即执行`,
  'marketing.people.custom.n03.rdo04': `定时执行`,
  'marketing.people.custom.n03.rdo05': `执行时间`,
  'marketing.people.custom.n03.placeholder06': `yyyy/mm/dd hh:mm`,
  'marketing.people.custom.n03.rdo07': `周期性`,
  'marketing.people.custom.n04.lbl01': `权益礼包`,
  'marketing.people.custom.n04.lbl02': `优惠券配置`,
  'marketing.people.custom.n04.btn03': `发放优惠券`,
  'marketing.people.custom.n04.lbl04': `发放优惠券能有效刺激转化（优惠券将直接发放给客户，不需要领取）`,
  'marketing.people.custom.d02.placeholder01': `请输入优惠券名称`,
  'marketing.people.custom.d02.lbl02': `选择优惠券`,
  'marketing.people.custom.d02.lbl03': `优惠券名称`,
  'marketing.people.custom.d02.lbl04': `适用商品`,
  'marketing.people.custom.d02.lbl05': `优惠内容`,
  'marketing.people.custom.d02.lbl06': `领取人限制`,
  'marketing.people.custom.d02.lbl07': `限领次数`,
  'marketing.people.custom.d02.lbl08': `剩余库存`,
  'marketing.people.custom.c02.lbl01': `优惠券`,
  'marketing.people.custom.c02.lbl02': `优惠券内容`,
  'marketing.people.custom.c02.lbl03': `库存`,
  'marketing.people.custom.c02.lbl04': `赠券数`,
  'marketing.people.custom.c02.lbl05': `操作`,
  'marketing.people.custom.n05.lbl01': `通知配置`,
  'marketing.people.custom.n05.lbl02': `通知渠道`,
  'marketing.people.custom.n05.chb03': `短信通知`,
  'marketing.people.custom.n05.rdo04': `选择消息`,
  'marketing.people.custom.n05.chb05': `微信模板消息`,
  'marketing.people.custom.n05.rdo06': `选择消息`,
  'marketing.people.custom.n06.lbl01': `通知规则`,
  'marketing.people.custom.n06.rdo02': `仅通知一个渠道`,
  'marketing.people.custom.c03.lbl01': `通知优先级`,
  'marketing.people.custom.c03.lbl02': `通知渠道`,
  'marketing.people.custom.c03.lbl03': `1`,
  'marketing.people.custom.c03.lbl04': `微信模板消息`,
  'marketing.people.custom.c03.lbl05': `2`,
  'marketing.people.custom.c03.lbl06': `短信`,
  'marketing.people.custom.n07.rdo01': `所有渠道同步通知`,
  'marketing.people.custom.n07.txt02': `同一个客户，多个渠道通知，有可能会骚扰客户，请谨慎使用`,
  'marketing.people.mpnumber.n01.lbl01': `基础信息`,
  'marketing.people.mpnumber.n01.lbl02': `活动名称`,
  'marketing.people.mpnumber.n01.lbl03': `活动人群`,
  'marketing.people.mpnumber.n01.lbl04': `请使用后缀为"csv"的文档`,
  'marketing.people.mpnumber.n01.btn05': `导入`,
  'marketing.people.mpnumber.c01.lbl01': `文件名`,
  'marketing.people.mpnumber.c01.lbl02': `后缀`,
  'marketing.people.mpnumber.c01.lbl03': `操作`,
  'marketing.people.mpnumber.n03.lbl01': `活动周期`,
  'marketing.people.mpnumber.n03.rdo02': `单次`,
  'marketing.people.mpnumber.n03.rdo03': `立即执行`,
  'marketing.people.mpnumber.n03.rdo04': `定时执行`,
  'marketing.people.mpnumber.n03.rdo05': `执行时间`,
  'marketing.people.mpnumber.n03.placeholder06': `yyyy/mm/dd hh:mm`,
  'marketing.people.mpnumber.n03.rdo07': `周期性`,
  'marketing.people.mpnumber.n04.lbl01': `权益礼包`,
  'marketing.people.mpnumber.n04.lbl02': `优惠券配置`,
  'marketing.people.mpnumber.n04.btn03': `发放优惠券`,
  'marketing.people.mpnumber.n04.lbl04': `发放优惠券能有效刺激转化（优惠券将直接发放给客户，不需要领取）`,
  'marketing.people.mpnumber.d02.placeholder01': `请输入优惠券名称`,
  'marketing.people.mpnumber.d02.lbl02': `选择优惠券`,
  'marketing.people.mpnumber.d02.lbl03': `优惠券名称`,
  'marketing.people.mpnumber.d02.lbl04': `适用商品`,
  'marketing.people.mpnumber.d02.lbl05': `优惠内容`,
  'marketing.people.mpnumber.d02.lbl06': `领取人限制`,
  'marketing.people.mpnumber.d02.lbl07': `限领次数`,
  'marketing.people.mpnumber.d02.lbl08': `剩余库存`,
  'marketing.people.mpnumber.c02.lbl01': `优惠券`,
  'marketing.people.mpnumber.c02.lbl02': `优惠券内容`,
  'marketing.people.mpnumber.c02.lbl03': `库存`,
  'marketing.people.mpnumber.c02.lbl04': `赠券数`,
  'marketing.people.mpnumber.c02.lbl05': `操作`,
  'marketing.people.mpnumber.n05.lbl01': `通知配置`,
  'marketing.people.mpnumber.n05.lbl02': `通知渠道`,
  'marketing.people.mpnumber.n05.chb03': `短信通知`,
  'marketing.people.mpnumber.n05.rdo04': `选择消息`,
  'marketing.people.mpnumber.n05.chb05': `微信模板消息`,
  'marketing.people.mpnumber.n05.rdo06': `选择消息`,
  'marketing.people.mpnumber.n06.lbl01': `通知规则`,
  'marketing.people.mpnumber.n06.rdo02': `仅通知一个渠道`,
  'marketing.people.mpnumber.c03.lbl01': `通知优先级`,
  'marketing.people.mpnumber.c03.lbl02': `通知渠道`,
  'marketing.people.mpnumber.c03.lbl03': `1`,
  'marketing.people.mpnumber.c03.lbl04': `微信模板消息`,
  'marketing.people.mpnumber.c03.lbl05': `2`,
  'marketing.people.mpnumber.c03.lbl06': `短信`,
  'marketing.people.mpnumber.n07.rdo01': `所有渠道同步通知`,
  'marketing.people.mpnumber.n07.txt02': `同一个客户，多个渠道通知，有可能会骚扰客户，请谨慎使用`,
  'marketing.event.n01.lbl01': `404`,
  'marketing.scene.holiday.c11.lbl01': `门店code`,
  'marketing.scene.holiday.c11.lbl02': `门店名称`,
  'marketing.scene.holiday.d03.lbl01': `选择门店`,
  'marketing.scene.holiday.d03.placeholder02': `请输入门店名称`,
};

export const marketing_enUS = {
  'marketing.menu': `MARKETING`, //营销活动
  'marketing.scene.menu': `SCENE MARKETING`, //场景营销
  'marketing.scene.holiday.menu': `HOLIDAYS MARKETING`, //节日营销
  'marketing.scene.reg.menu': `MEMBER REGISTARTING MARKETING`, //会员注册营销
  'marketing.scene.birth.menu': `BIRTHDAY MARKETING`, //生日营销
  'marketing.scene.memberday.menu': `MEMBER DAY MARKETING`, //会员日营销
  'marketing.scene.binding.menu': `MEMBERS BINDING`, //会员绑定
  'marketing.scene.consume.menu': `MEMBERS COUSUMING`, //会员消费
  'marketing.scene.rank.menu': `RANK CHANGING`, //等级变更
  'marketing.scene.data.menu': `活动数据`, //活动数据
  'marketing.scene.points.menu': `POINTS USING`, //积分使用
  'marketing.people.menu': `OPERATION`, //人群运营
  'marketing.people.regnotcon.menu': `NOT PURCHASED BUT REGISTRATED`, //注册未支付用户
  'marketing.people.imprecall.menu': `IMPORTANT INACTIVE MEMBERS`, //需重点召回用户
  'marketing.people.custom.menu': `CUSTOM`, //自定义人群
  'marketing.people.mpnumber.menu': `BY MP NUMBER`, //指定手机号用户
  'marketing.event.menu': `EVENT`, //活动运营
  'marketing.scene.n01.lbl01': `HOLIDAYS MARKETING`,
  'marketing.scene.n01.lbl02': `SETTING ATMOSPHERE OF HOLIDAYS`,
  'marketing.scene.n01.lbl03': `IMPROVE SALES`, //提升店铺营销额
  'marketing.scene.n02.lbl01': `MEMBER REGISTARTING MARKETING`,
  'marketing.scene.n02.lbl02': `ATTRACTING PEOPLE TO BE MEMBERS`,
  'marketing.scene.n02.lbl03': `IMPROVE AMOUNT OF MEMBERS`, //提高会员拉新
  'marketing.scene.n03.lbl01': `BIRTHDAY MARKETING`,
  'marketing.scene.n03.lbl02': `DISCOUNTS FOR MEMBERS IN SPECIFIC TIME`,
  'marketing.scene.n03.lbl03': `IMPROVE SALES AND BUYER RETENTION`, //提高店铺销量和复购
  'marketing.scene.n04.lbl01': `MEMBER DAY MARKETING`,
  'marketing.scene.n04.lbl02': `MEMBER DAY EVENT`,
  'marketing.scene.n04.lbl03': `IMPROVE VISCOSITY OF MEMBERS`, //提高客户黏性
  'marketing.scene.n05.lbl01': `MEMBERS BINDING`,
  'marketing.scene.n05.lbl02': `MEMBER DAY EVENT`,
  'marketing.scene.n05.lbl03': `IMPROVE VISCOSITY OF MEMBERS`, //提高客户黏性
  'marketing.scene.n06.lbl01': `MEMBERS COUSUMING`,
  'marketing.scene.n06.lbl02': `MEMBER DAY EVENT`,
  'marketing.scene.n06.lbl03': `IMPROVE VISCOSITY OF MEMBERS`, //提高客户黏性
  'marketing.scene.n07.lbl01': `RANK CHANGING`,
  'marketing.scene.n07.lbl02': `MEMBER DAY EVENT`,
  'marketing.scene.n07.lbl03': `IMPROVE VISCOSITY OF MEMBERS`, //提高客户黏性
  'marketing.scene.n08.lbl01': `POINTS USING`,
  'marketing.scene.n08.lbl02': `MEMBER DAY EVENT`,
  'marketing.scene.n08.lbl03': `IMPROVE VISCOSITY OF MEMBERS`, //提高客户黏性
  'marketing.scene.n09.lbl01': `NAME`,
  'marketing.scene.n09.rdo02': `TYPE`,
  'marketing.scene.n09.rdo03': `STATUS`,
  'marketing.scene.c01.lbl01': `MARKETING NAME`,
  'marketing.scene.c01.txt01': `The event name must be filled`, //活动名称为必填项
  'marketing.scene.c01.txt02': `Please choose date`, //请选择时间
  'marketing.scene.c01.txt03': `Please Choose Month`, //请选择月份
  'marketing.scene.c01.txt04': `Please Choose Day`, //请选择日期
  'marketing.scene.c01.txt05': `Please Choose Start Day`, //请选择开始日期
  'marketing.scene.c01.txt06': `Please Choose End Day`, //请选择结束日期
  'marketing.scene.c01.txt07': `Start Day must smaller than End day`, //开始日期不得大于结束日期
  'marketing.scene.c01.lbl02': `TYPE`,
  'marketing.scene.c01.lbl03': `TIME`,
  'marketing.scene.c01.lbl04': `MEMBERS RANK`,
  'marketing.scene.c01.lbl05': `STATUS`,
  'marketing.scene.c01.lbl06': `ACTIONS`,
  'marketing.scene.n10.lbl01': `NAME`,
  'marketing.scene.n10.lbl02': `TYPE`,
  'marketing.scene.n10.lbl03': `STATUS`,
  'marketing.scene.holiday.n01.lbl01': `BASIC OPTION`,
  'marketing.scene.holiday.n01.lbl02': `NAME`,
  'marketing.scene.holiday.n01.lbl03': `TIME`,
  'marketing.scene.holiday.n01.rdo04': `BEGIN FROM`,
  'marketing.scene.holiday.n01.lbl05': `TO`,
  'marketing.scene.holiday.n01.rdo06': `END`,
  'marketing.scene.holiday.n02.lbl01': `RIGHTS AND INTERESTS`,
  'marketing.scene.holiday.n02.chb02': `RANK RULE`,
  'marketing.scene.holiday.n02.rdo03': `ALL SAME RULE`,
  'marketing.scene.holiday.c01.lbl01': `RANK`,
  'marketing.scene.holiday.c01.lbl02': `DISCOUNT`,
  'marketing.scene.holiday.c01.lbl03': `POINTS GIVE BACK`,
  'marketing.scene.holiday.c01.lbl04': `POINTS GIVE AWAY`,
  'marketing.scene.holiday.c01.lbl05': `VOUCHERS GIVE AWAY`,
  'marketing.scene.holiday.c01.lbl06': `STATUS`,
  'marketing.scene.holiday.c02.txt01': `Setting`, //设置
  'marketing.scene.holiday.c02.txt02': `Edit`, //修改
  'marketing.scene.holiday.c02.txt03': `On`, //开启
  'marketing.scene.holiday.c02.txt04': `Off`, //关闭
  'marketing.scene.holiday.n03.rdo01': `DIFFERENT RULES TO DIFFERENT RANKS`,
  'marketing.scene.holiday.c02.lbl01': `RANK`,
  'marketing.scene.holiday.c02.lbl02': `DISCOUNT`,
  'marketing.scene.holiday.c02.lbl03': `POINTS GIVE BACK`,
  'marketing.scene.holiday.c02.lbl04': `POINTS GIVE AWAY`,
  'marketing.scene.holiday.c02.lbl05': `VOUCHERS GIVE AWAY`,
  'marketing.scene.holiday.c02.lbl06': `STATUS`,
  'marketing.scene.holiday.c02.lbl07': `RANK I`,
  'marketing.scene.holiday.c02.lbl08': `RANK II`,
  'marketing.scene.holiday.c02.lbl09': `RANK III`,
  'marketing.scene.holiday.c02.lbl10': `RANK IV`,
  'marketing.scene.holiday.n04.lbl01': `FIRST ORDER LIMIT`,
  'marketing.scene.holiday.n04.rdo02': `RIGHTS ON ALL ORDERS`,
  'marketing.scene.holiday.n04.rdo03': `RIGHTS ON ONLY FIRST ORDER`,
  'marketing.scene.holiday.n04.chb04': `RULES`,
  'marketing.scene.holiday.n04.rdo05': `ONLY SPECIFIC ITEMS`,
  'marketing.scene.holiday.n04.rdo06': `ALL ITEMS`,
  'marketing.scene.holiday.n05.btn01': `ADD`,
  'marketing.scene.holiday.d01.placeholder01': `PLEASE ENTER VOUCHER NAME`,
  'marketing.scene.holiday.d01.lbl02': `CHOOSE VOUCHERS`,
  'marketing.scene.holiday.d01.lbl03': `VOUCHER NAME`,
  'marketing.scene.holiday.d01.lbl04': `USED FOR`,
  'marketing.scene.holiday.d01.lbl05': `DETAILS`,
  'marketing.scene.holiday.d01.lbl06': `PEOPLE LIMITED`,
  'marketing.scene.holiday.d01.lbl07': `TIMES LIMITED`,
  'marketing.scene.holiday.d01.lbl08': `REMAINING`,
  'marketing.scene.holiday.d02.lbl01': `STYLE NUMBER`,
  'marketing.scene.holiday.d02.lbl02': `ITEM NUMBER`,
  'marketing.scene.holiday.d02.lbl03': `SKU`,
  'marketing.scene.holiday.d02.lbl04': `SERIES`,
  'marketing.scene.holiday.d02.lbl05': `GLOBAL SEASON`,
  'marketing.scene.holiday.d02.lbl06': `CATEGORY`,
  'marketing.scene.holiday.d02.lbl07': `MAIN CATEGORY`,
  'marketing.scene.holiday.n06.lbl01': `STYLE NUMBER`,
  'marketing.scene.holiday.n06.lbl02': `ITEM NUMBER`,
  'marketing.scene.holiday.n06.lbl03': `SKU`,
  'marketing.scene.holiday.n06.lbl04': `SERIES`,
  'marketing.scene.holiday.n06.lbl05': `GLOBAL SEASON`,
  'marketing.scene.holiday.n06.lbl06': `CATEGORY`,
  'marketing.scene.holiday.n06.lbl07': `MAIN CATEGORY`,
  'marketing.scene.holiday.c03.lbl01': `CODING`,
  'marketing.scene.holiday.c03.lbl02': `NAME`,
  'marketing.scene.holiday.c03.lbl03': `DISCOUNT`,
  'marketing.scene.holiday.c03.lbl04': `POINTS GIVE BACK`,
  'marketing.scene.holiday.c03.lbl05': `POINTS GIVE AWAY`,
  'marketing.scene.holiday.c03.lbl06': `VOUCHERS GIVE AWAY`,
  'marketing.scene.holiday.c03.lbl07': `ACTION`,
  'marketing.scene.holiday.c04.lbl01': `CODING`,
  'marketing.scene.holiday.c04.lbl02': `NAME`,
  'marketing.scene.holiday.c04.lbl03': `DISCOUNT`,
  'marketing.scene.holiday.c04.lbl04': `POINTS GIVE BACK`,
  'marketing.scene.holiday.c04.lbl05': `POINTS GIVE AWAY`,
  'marketing.scene.holiday.c04.lbl06': `VOUCHERS GIVE AWAY`,
  'marketing.scene.holiday.c04.lbl07': `ACTION`,
  'marketing.scene.holiday.c05.lbl01': `SKU`,
  'marketing.scene.holiday.c05.lbl02': `DETAIL`,
  'marketing.scene.holiday.c05.lbl03': `DISCOUNT`,
  'marketing.scene.holiday.c05.lbl04': `POINTS GIVE BACK`,
  'marketing.scene.holiday.c05.lbl05': `POINTS GIVE AWAY`,
  'marketing.scene.holiday.c05.lbl06': `VOUCHERS GIVE AWAY`,
  'marketing.scene.holiday.c05.lbl07': `ACTION`,
  'marketing.scene.holiday.c06.lbl01': `CODING`,
  'marketing.scene.holiday.c06.lbl02': `NAME`,
  'marketing.scene.holiday.c06.lbl03': `DISCOUNT`,
  'marketing.scene.holiday.c06.lbl04': `POINTS GIVE BACK`,
  'marketing.scene.holiday.c06.lbl05': `POINTS GIVE AWAY`,
  'marketing.scene.holiday.c06.lbl06': `VOUCHERS GIVE AWAY`,
  'marketing.scene.holiday.c06.lbl07': `ACTION`,
  'marketing.scene.holiday.c07.lbl01': `CODING`,
  'marketing.scene.holiday.c07.lbl02': `NAME`,
  'marketing.scene.holiday.c07.lbl03': `DISCOUNT`,
  'marketing.scene.holiday.c07.lbl04': `POINTS GIVE BACK`,
  'marketing.scene.holiday.c07.lbl05': `POINTS GIVE AWAY`,
  'marketing.scene.holiday.c07.lbl06': `VOUCHERS GIVE AWAY`,
  'marketing.scene.holiday.c07.lbl07': `ACTION`,
  'marketing.scene.holiday.c08.lbl01': `CODING`,
  'marketing.scene.holiday.c08.lbl02': `NAME`,
  'marketing.scene.holiday.c08.lbl03': `DISCOUNT`,
  'marketing.scene.holiday.c08.lbl04': `POINTS GIVE BACK`,
  'marketing.scene.holiday.c08.lbl05': `POINTS GIVE AWAY`,
  'marketing.scene.holiday.c08.lbl06': `VOUCHERS GIVE AWAY`,
  'marketing.scene.holiday.c08.lbl07': `ACTION`,
  'marketing.scene.holiday.c09.lbl01': `CODING`,
  'marketing.scene.holiday.c09.lbl02': `NAME`,
  'marketing.scene.holiday.c09.lbl03': `DISCOUNT`,
  'marketing.scene.holiday.c09.lbl04': `POINTS GIVE BACK`,
  'marketing.scene.holiday.c09.lbl05': `POINTS GIVE AWAY`,
  'marketing.scene.holiday.c09.lbl06': `VOUCHERS GIVE AWAY`,
  'marketing.scene.holiday.c09.lbl07': `ACTION`,
  'marketing.scene.holiday.n07.lbl01': `COMPANY RULES`,
  'marketing.scene.holiday.n07.rdo02': `ALL COMPANY`,
  'marketing.scene.holiday.n07.rdo03': `SPECIFIC COMPANIES`,
  'marketing.scene.holiday.n07.rdo04': `COMPANY NAME`,
  'marketing.scene.holiday.n08.lbl01': `STORE RULES`,
  'marketing.scene.holiday.n08.rdo02': `ALL STORES`,
  'marketing.scene.holiday.n08.rdo03': `ONLY NO-DISCOUNT STORES`,
  'marketing.scene.holiday.n08.rdo04': `SPECIFIC STORES`,
  'marketing.scene.holiday.n09.lbl01': `NOTIFY SETTINGS`,
  'marketing.scene.holiday.n09.lbl02': `SOURCE OF NOTIFIES`,
  'marketing.scene.holiday.n09.chb03': `MESSAGE`,
  'marketing.scene.holiday.n09.rdo04': `CHOOSE MESSAGE`,
  'marketing.scene.holiday.n09.chb05': `WECHAT MESSAGE`,
  'marketing.scene.holiday.n09.rdo06': `CHOOSE MESSAGE`,
  'marketing.scene.holiday.n10.lbl01': `NOTIFY RULES`,
  'marketing.scene.holiday.n10.rdo02': `ONLY ONE SOURCE`,
  'marketing.scene.holiday.c10.lbl01': `PRIORITY OF NOTIFIES`,
  'marketing.scene.holiday.c10.lbl02': `SOURCE OF NOTIFIES`,
  'marketing.scene.holiday.c10.lbl03': `1`,
  'marketing.scene.holiday.c10.lbl04': `WECHAT MESSAGE`,
  'marketing.scene.holiday.c10.lbl05': `2`,
  'marketing.scene.holiday.c10.lbl06': `MESSAGE`,
  'marketing.scene.holiday.n11.rdo01': `ALL SOURCES`,
  'marketing.scene.holiday.n11.txt02': `THIS SELECTION MAY BE ANNOYING,PLEASE BE CAUTIOUS BEFORE USING IT.`,
  'marketing.scene.reg.n01.lbl01': `BASIC OPTION`,
  'marketing.scene.reg.n01.lbl02': `NAME`,
  'marketing.scene.reg.n02.lbl01': `RIGHTS AND INTERESTS`,
  'marketing.scene.reg.n02.chb02': `RANK RULE`,
  'marketing.scene.reg.c01.lbl01': `RANK`,
  'marketing.scene.reg.c01.lbl02': `DISCOUNT`,
  'marketing.scene.reg.c01.lbl03': `POINTS GIVE BACK`,
  'marketing.scene.reg.c01.lbl04': `POINTS GIVE AWAY`,
  'marketing.scene.reg.c01.lbl05': `VOUCHERS GIVE AWAY`,
  'marketing.scene.reg.c01.lbl06': `STATUS`,
  'marketing.scene.reg.d01.placeholder01': `PLEASE ENTER VOUCHER NAME`,
  'marketing.scene.reg.d01.lbl02': `CHOOSE VOUCHERS`,
  'marketing.scene.reg.d01.lbl03': `VOUCHER NAME`,
  'marketing.scene.reg.d01.lbl04': `USED FOR`,
  'marketing.scene.reg.d01.lbl05': `DETAILS`,
  'marketing.scene.reg.d01.lbl06': `PEOPLE LIMITED`,
  'marketing.scene.reg.d01.lbl07': `TIMES LIMITED`,
  'marketing.scene.reg.d01.lbl08': `REMAINING`,
  'marketing.scene.reg.n03.lbl01': `NOTIFY SETTINGS`,
  'marketing.scene.reg.n03.lbl02': `SOURCE OF NOTIFIES`,
  'marketing.scene.reg.n03.chb03': `MESSAGE`,
  'marketing.scene.reg.n03.rdo04': `CHOOSE MESSAGE`,
  'marketing.scene.reg.n03.chb05': `WECHAT MESSAGE`,
  'marketing.scene.reg.n03.rdo06': `CHOOSE MESSAGE`,
  'marketing.scene.reg.n04.lbl01': `NOTIFY RULES`,
  'marketing.scene.reg.n04.rdo02': `ONLY ONE SOURCE`,
  'marketing.scene.reg.c02.lbl01': `PRIORITY OF NOTIFIES`,
  'marketing.scene.reg.c02.lbl02': `SOURCE OF NOTIFIES`,
  'marketing.scene.reg.c02.lbl03': `1`,
  'marketing.scene.reg.c02.lbl04': `WECHAT MESSAGE`,
  'marketing.scene.reg.c02.lbl05': `2`,
  'marketing.scene.reg.c02.lbl06': `MESSAGE`,
  'marketing.scene.reg.n05.rdo01': `ALL SOURCES`,
  'marketing.scene.reg.n05.txt02': `THIS SELECTION MAY BE ANNOYING,PLEASE BE CAUTIOUS BEFORE USING IT.`,
  'marketing.scene.birth.n01.lbl01': `BASIC OPTION`,
  'marketing.scene.birth.n01.lbl02': `NAME`,
  'marketing.scene.birth.n01.lbl03': `CYCLING`,
  'marketing.scene.birth.n01.rdo04': `BIRTHDAY THAT DAY`,
  'marketing.scene.birth.n01.rdo05': `BIRTHDAY THAT MONTH`,
  'marketing.scene.birth.n01.rdo06': ` `,
  'marketing.scene.birth.n01.chb06': `NOT GIVE IF REGISTRATED IN BIRTHDAY THAT MONTH`,
  'marketing.scene.birth.n02.lbl01': `RIGHTS AND INTERESTS`,
  'marketing.scene.birth.n02.chb02': `RANK RULE`,
  'marketing.scene.birth.n02.rdo03': `ALL SAME RULE`,
  'marketing.scene.birth.c01.lbl01': `RANK`,
  'marketing.scene.birth.c01.lbl02': `DISCOUNT`,
  'marketing.scene.birth.c01.lbl03': `POINTS GIVE BACK`,
  'marketing.scene.birth.c01.lbl04': `POINTS GIVE AWAY`,
  'marketing.scene.birth.c01.lbl05': `VOUCHERS GIVE AWAY`,
  'marketing.scene.birth.c01.lbl06': `STATUS`,
  'marketing.scene.birth.d01.placeholder01': `PLEASE ENTER VOUCHER NAME`,
  'marketing.scene.birth.d01.lbl02': `CHOOSE VOUCHERS`,
  'marketing.scene.birth.d01.lbl03': `VOUCHER NAME`,
  'marketing.scene.birth.d01.lbl04': `USED FOR`,
  'marketing.scene.birth.d01.lbl05': `DETAILS`,
  'marketing.scene.birth.d01.lbl06': `PEOPLE LIMITED`,
  'marketing.scene.birth.d01.lbl07': `TIMES LIMITED`,
  'marketing.scene.birth.d01.lbl08': `REMAINING`,
  'marketing.scene.birth.n03.rdo01': `DIFFERENT RULES TO DIFFERENT RANKS`,
  'marketing.scene.birth.c02.lbl01': `RANK`,
  'marketing.scene.birth.c02.lbl02': `DISCOUNT`,
  'marketing.scene.birth.c02.lbl03': `POINTS GIVE BACK`,
  'marketing.scene.birth.c02.lbl04': `POINTS GIVE AWAY`,
  'marketing.scene.birth.c02.lbl05': `VOUCHERS GIVE AWAY`,
  'marketing.scene.birth.c02.lbl06': `STATUS`,
  'marketing.scene.birth.c02.lbl07': `RANK I`,
  'marketing.scene.birth.c02.lbl08': `RANK II`,
  'marketing.scene.birth.c02.lbl09': `RANK III`,
  'marketing.scene.birth.c02.lbl10': `RANK IV`,
  'marketing.scene.birth.n04.lbl01': `FIRST ORDER LIMIT`,
  'marketing.scene.birth.n04.rdo02': `RIGHTS ON ALL ORDERS`,
  'marketing.scene.birth.n04.rdo03': `RIGHTS ON ONLY FIRST ORDER`,
  'marketing.scene.birth.n05.lbl01': `NOTIFY SETTINGS`,
  'marketing.scene.birth.n05.lbl02': `SOURCE OF NOTIFIES`,
  'marketing.scene.birth.n05.chb03': `MESSAGE`,
  'marketing.scene.birth.n05.rdo04': `CHOOSE MESSAGE`,
  'marketing.scene.birth.n05.chb05': `WECHAT MESSAGE`,
  'marketing.scene.birth.n05.rdo06': `CHOOSE MESSAGE`,
  'marketing.scene.birth.n06.lbl01': `NOTIFY RULES`,
  'marketing.scene.birth.n06.rdo02': `ONLY ONE SOURCE`,
  'marketing.scene.birth.c03.lbl01': `PRIORITY OF NOTIFIES`,
  'marketing.scene.birth.c03.lbl02': `SOURCE OF NOTIFIES`,
  'marketing.scene.birth.c03.lbl03': `1`,
  'marketing.scene.birth.c03.lbl04': `WECHAT MESSAGE`,
  'marketing.scene.birth.c03.lbl05': `2`,
  'marketing.scene.birth.c03.lbl06': `MESSAGE`,
  'marketing.scene.birth.n07.rdo01': `ALL SOURCES`,
  'marketing.scene.birth.n07.txt02': `THIS SELECTION MAY BE ANNOYING,PLEASE BE CAUTIOUS BEFORE USING IT.`,
  'marketing.scene.memberday.n01.lbl01': `BASIC OPTION`,
  'marketing.scene.memberday.n01.lbl02': `NAME`,
  'marketing.scene.memberday.n01.lbl03': `CYCLING`,
  'marketing.scene.memberday.n01.rdo04': `BEGIN FROM`,
  'marketing.scene.memberday.n01.rdo05': `TO`,
  'marketing.scene.memberday.n01.rdo06': `SPECIFIC DAY`,
  'marketing.scene.memberday.n02.lbl01': `RIGHTS AND INTERESTS`,
  'marketing.scene.memberday.n02.chb02': `RANK RULE`,
  'marketing.scene.memberday.n02.rdo03': `ALL SAME RULE`,
  'marketing.scene.memberday.c01.lbl01': `RANK`,
  'marketing.scene.memberday.c01.lbl02': `DISCOUNT`,
  'marketing.scene.memberday.c01.lbl03': `POINTS GIVE BACK`,
  'marketing.scene.memberday.c01.lbl04': `POINTS GIVE AWAY`,
  'marketing.scene.memberday.c01.lbl05': `VOUCHERS GIVE AWAY`,
  'marketing.scene.memberday.c01.lbl06': `STATUS`,
  'marketing.scene.memberday.d01.placeholder01': `PLEASE ENTER VOUCHER NAME`,
  'marketing.scene.memberday.d01.lbl02': `CHOOSE VOUCHERS`,
  'marketing.scene.memberday.d01.lbl03': `VOUCHER NAME`,
  'marketing.scene.memberday.d01.lbl04': `USED FOR`,
  'marketing.scene.memberday.d01.lbl05': `DETAILS`,
  'marketing.scene.memberday.d01.lbl06': `PEOPLE LIMITED`,
  'marketing.scene.memberday.d01.lbl07': `TIMES LIMITED`,
  'marketing.scene.memberday.d01.lbl08': `REMAINING`,
  'marketing.scene.memberday.n03.rdo01': `DIFFERENT RULES TO DIFFERENT RANKS`,
  'marketing.scene.memberday.c02.lbl01': `RANK`,
  'marketing.scene.memberday.c02.lbl02': `DISCOUNT`,
  'marketing.scene.memberday.c02.lbl03': `POINTS GIVE BACK`,
  'marketing.scene.memberday.c02.lbl04': `POINTS GIVE AWAY`,
  'marketing.scene.memberday.c02.lbl05': `VOUCHERS GIVE AWAY`,
  'marketing.scene.memberday.c02.lbl06': `STATUS`,
  'marketing.scene.memberday.c02.lbl07': `RANK I`,
  'marketing.scene.memberday.c02.lbl08': `RANK II`,
  'marketing.scene.memberday.c02.lbl09': `RANK III`,
  'marketing.scene.memberday.c02.lbl10': `RANK IV`,
  'marketing.scene.memberday.n04.lbl01': `FIRST ORDER LIMIT`,
  'marketing.scene.memberday.n04.rdo02': `RIGHTS ON ALL ORDERS`,
  'marketing.scene.memberday.n04.rdo03': `RIGHTS ON ONLY FIRST ORDER`,
  'marketing.scene.memberday.n05.lbl01': `STORE RULES`,
  'marketing.scene.memberday.n05.rdo02': `ALL STORES`,
  'marketing.scene.memberday.n05.rdo03': `ONLY NO-DISCOUNT STORES`,
  'marketing.scene.memberday.n05.rdo04': `SPECIFIC STORES`,
  'marketing.scene.memberday.n06.lbl01': `NOTIFY SETTINGS`,
  'marketing.scene.memberday.n06.lbl02': `SOURCE OF NOTIFIES`,
  'marketing.scene.memberday.n06.chb03': `MESSAGE`,
  'marketing.scene.memberday.n06.rdo04': `CHOOSE MESSAGE`,
  'marketing.scene.memberday.n06.chb05': `WECHAT MESSAGE`,
  'marketing.scene.memberday.n06.rdo06': `CHOOSE MESSAGE`,
  'marketing.scene.memberday.n07.lbl01': `NOTIFY RULES`,
  'marketing.scene.memberday.n07.rdo02': `ONLY ONE SOURCE`,
  'marketing.scene.memberday.c03.lbl01': `PRIORITY OF NOTIFIES`,
  'marketing.scene.memberday.c03.lbl02': `SOURCE OF NOTIFIES`,
  'marketing.scene.memberday.c03.lbl03': `1`,
  'marketing.scene.memberday.c03.lbl04': `WECHAT MESSAGE`,
  'marketing.scene.memberday.c03.lbl05': `2`,
  'marketing.scene.memberday.c03.lbl06': `MESSAGE`,
  'marketing.scene.memberday.n08.rdo01': `ALL SOURCES`,
  'marketing.scene.memberday.n08.txt02': `THIS SELECTION MAY BE ANNOYING,PLEASE BE CAUTIOUS BEFORE USING IT.`,
  'marketing.scene.binding.n01.lbl01': `BASIC OPTION`,
  'marketing.scene.binding.n01.lbl02': `NAME`,
  'marketing.scene.binding.n02.lbl01': `RIGHTS AND INTERESTS`,
  'marketing.scene.binding.n02.chb02': `RANK RULE`,
  'marketing.scene.binding.n02.rdo03': `ALL SAME RULE`,
  'marketing.scene.binding.c01.lbl01': `RANK`,
  'marketing.scene.binding.c01.lbl02': `DISCOUNT`,
  'marketing.scene.binding.c01.lbl03': `POINTS GIVE BACK`,
  'marketing.scene.binding.c01.lbl04': `POINTS GIVE AWAY`,
  'marketing.scene.binding.c01.lbl05': `VOUCHERS GIVE AWAY`,
  'marketing.scene.binding.c01.lbl06': `STATUS`,
  'marketing.scene.binding.d01.placeholder01': `PLEASE ENTER VOUCHER NAME`,
  'marketing.scene.binding.d01.lbl02': `CHOOSE VOUCHERS`,
  'marketing.scene.binding.d01.lbl03': `VOUCHER NAME`,
  'marketing.scene.binding.d01.lbl04': `USED FOR`,
  'marketing.scene.binding.d01.lbl05': `DETAILS`,
  'marketing.scene.binding.d01.lbl06': `PEOPLE LIMITED`,
  'marketing.scene.binding.d01.lbl07': `TIMES LIMITED`,
  'marketing.scene.binding.d01.lbl08': `REMAINING`,
  'marketing.scene.binding.n03.rdo01': `DIFFERENT RULES TO DIFFERENT RANKS`,
  'marketing.scene.binding.c02.lbl01': `RANK`,
  'marketing.scene.binding.c02.lbl02': `DISCOUNT`,
  'marketing.scene.binding.c02.lbl03': `POINTS GIVE BACK`,
  'marketing.scene.binding.c02.lbl04': `POINTS GIVE AWAY`,
  'marketing.scene.binding.c02.lbl05': `VOUCHERS GIVE AWAY`,
  'marketing.scene.binding.c02.lbl06': `STATUS`,
  'marketing.scene.binding.c02.lbl07': `RANK I`,
  'marketing.scene.binding.c02.lbl08': `RANK II`,
  'marketing.scene.binding.c02.lbl09': `RANK III`,
  'marketing.scene.binding.c02.lbl10': `RANK IV`,
  'marketing.scene.binding.n04.lbl01': `FIRST ORDER LIMIT`,
  'marketing.scene.binding.n04.rdo02': `RIGHTS ON ALL ORDERS`,
  'marketing.scene.binding.n04.rdo03': `RIGHTS ON ONLY FIRST ORDER`,
  'marketing.scene.binding.n05.lbl01': `NOTIFY SETTINGS`,
  'marketing.scene.binding.n05.lbl02': `SOURCE OF NOTIFIES`,
  'marketing.scene.binding.n05.chb03': `MESSAGE`,
  'marketing.scene.binding.n05.rdo04': `CHOOSE MESSAGE`,
  'marketing.scene.binding.n05.chb05': `WECHAT MESSAGE`,
  'marketing.scene.binding.n05.rdo06': `CHOOSE MESSAGE`,
  'marketing.scene.binding.n06.lbl01': `NOTIFY RULES`,
  'marketing.scene.binding.n06.rdo02': `ONLY ONE SOURCE`,
  'marketing.scene.binding.c03.lbl01': `PRIORITY OF NOTIFIES`,
  'marketing.scene.binding.c03.lbl02': `SOURCE OF NOTIFIES`,
  'marketing.scene.binding.c03.lbl03': `1`,
  'marketing.scene.binding.c03.lbl04': `WECHAT MESSAGE`,
  'marketing.scene.binding.c03.lbl05': `2`,
  'marketing.scene.binding.c03.lbl06': `MESSAGE`,
  'marketing.scene.binding.n07.rdo01': `ALL SOURCES`,
  'marketing.scene.binding.n07.txt02': `THIS SELECTION MAY BE ANNOYING,PLEASE BE CAUTIOUS BEFORE USING IT.`,
  'marketing.scene.consume.n01.lbl01': `BASIC OPTION`,
  'marketing.scene.consume.n01.lbl02': `NAME`,
  'marketing.scene.consume.n02.lbl01': `RIGHTS AND INTERESTS`,
  'marketing.scene.consume.n02.chb02': `RANK RULE`,
  'marketing.scene.consume.n02.rdo03': `ALL SAME RULE`,
  'marketing.scene.consume.c01.lbl01': `RANK`,
  'marketing.scene.consume.c01.lbl02': `DISCOUNT`,
  'marketing.scene.consume.c01.lbl03': `POINTS GIVE BACK`,
  'marketing.scene.consume.c01.lbl04': `POINTS GIVE AWAY`,
  'marketing.scene.consume.c01.lbl05': `VOUCHERS GIVE AWAY`,
  'marketing.scene.consume.c01.lbl06': `STATUS`,
  'marketing.scene.consume.d01.placeholder01': `PLEASE ENTER VOUCHER NAME`,
  'marketing.scene.consume.d01.lbl02': `CHOOSE VOUCHERS`,
  'marketing.scene.consume.d01.lbl03': `VOUCHER NAME`,
  'marketing.scene.consume.d01.lbl04': `USED FOR`,
  'marketing.scene.consume.d01.lbl05': `DETAILS`,
  'marketing.scene.consume.d01.lbl06': `PEOPLE LIMITED`,
  'marketing.scene.consume.d01.lbl07': `TIMES LIMITED`,
  'marketing.scene.consume.d01.lbl08': `REMAINING`,
  'marketing.scene.consume.n03.rdo01': `DIFFERENT RULES TO DIFFERENT RANKS`,
  'marketing.scene.consume.c02.lbl01': `RANK`,
  'marketing.scene.consume.c02.lbl02': `DISCOUNT`,
  'marketing.scene.consume.c02.lbl03': `POINTS GIVE BACK`,
  'marketing.scene.consume.c02.lbl04': `POINTS GIVE AWAY`,
  'marketing.scene.consume.c02.lbl05': `VOUCHERS GIVE AWAY`,
  'marketing.scene.consume.c02.lbl06': `STATUS`,
  'marketing.scene.consume.c02.lbl07': `RANK I`,
  'marketing.scene.consume.c02.lbl08': `RANK II`,
  'marketing.scene.consume.c02.lbl09': `RANK III`,
  'marketing.scene.consume.c02.lbl10': `RANK IV`,
  'marketing.scene.consume.n04.lbl01': `FIRST ORDER LIMIT`,
  'marketing.scene.consume.n04.rdo02': `RIGHTS ON ALL ORDERS`,
  'marketing.scene.consume.n04.rdo03': `RIGHTS ON ONLY FIRST ORDER`,
  'marketing.scene.consume.n05.lbl01': `NOTIFY SETTINGS`,
  'marketing.scene.consume.n05.lbl02': `SOURCE OF NOTIFIES`,
  'marketing.scene.consume.n05.chb03': `MESSAGE`,
  'marketing.scene.consume.n05.rdo04': `CHOOSE MESSAGE`,
  'marketing.scene.consume.n05.chb05': `WECHAT MESSAGE`,
  'marketing.scene.consume.n05.rdo06': `CHOOSE MESSAGE`,
  'marketing.scene.consume.n06.lbl01': `NOTIFY RULES`,
  'marketing.scene.consume.n06.rdo02': `ONLY ONE SOURCE`,
  'marketing.scene.consume.c03.lbl01': `PRIORITY OF NOTIFIES`,
  'marketing.scene.consume.c03.lbl02': `SOURCE OF NOTIFIES`,
  'marketing.scene.consume.c03.lbl03': `1`,
  'marketing.scene.consume.c03.lbl04': `WECHAT MESSAGE`,
  'marketing.scene.consume.c03.lbl05': `2`,
  'marketing.scene.consume.c03.lbl06': `MESSAGE`,
  'marketing.scene.consume.n07.rdo01': `ALL SOURCES`,
  'marketing.scene.consume.n07.txt02': `THIS SELECTION MAY BE ANNOYING,PLEASE BE CAUTIOUS BEFORE USING IT.`,
  'marketing.scene.rank.n01.lbl01': `BASIC OPTION`,
  'marketing.scene.rank.n01.lbl02': `NAME`,
  'marketing.scene.rank.n02.lbl01': `RIGHTS AND INTERESTS`,
  'marketing.scene.rank.n02.chb02': `RANK RULE`,
  'marketing.scene.rank.n02.rdo03': `ALL SAME RULE`,
  'marketing.scene.rank.c01.lbl01': `RANK`,
  'marketing.scene.rank.c01.lbl02': `DISCOUNT`,
  'marketing.scene.rank.c01.lbl03': `POINTS GIVE BACK`,
  'marketing.scene.rank.c01.lbl04': `POINTS GIVE AWAY`,
  'marketing.scene.rank.c01.lbl05': `VOUCHERS GIVE AWAY`,
  'marketing.scene.rank.c01.lbl06': `STATUS`,
  'marketing.scene.rank.d01.placeholder01': `PLEASE ENTER VOUCHER NAME`,
  'marketing.scene.rank.d01.lbl02': `CHOOSE VOUCHERS`,
  'marketing.scene.rank.d01.lbl03': `VOUCHER NAME`,
  'marketing.scene.rank.d01.lbl04': `USED FOR`,
  'marketing.scene.rank.d01.lbl05': `DETAILS`,
  'marketing.scene.rank.d01.lbl06': `PEOPLE LIMITED`,
  'marketing.scene.rank.d01.lbl07': `TIMES LIMITED`,
  'marketing.scene.rank.d01.lbl08': `REMAINING`,
  'marketing.scene.rank.n03.rdo01': `DIFFERENT RULES TO DIFFERENT RANKS`,
  'marketing.scene.rank.c02.lbl01': `RANK`,
  'marketing.scene.rank.c02.lbl02': `DISCOUNT`,
  'marketing.scene.rank.c02.lbl03': `POINTS GIVE BACK`,
  'marketing.scene.rank.c02.lbl04': `POINTS GIVE AWAY`,
  'marketing.scene.rank.c02.lbl05': `VOUCHERS GIVE AWAY`,
  'marketing.scene.rank.c02.lbl06': `STATUS`,
  'marketing.scene.rank.c02.lbl07': `RANK I`,
  'marketing.scene.rank.c02.lbl08': `RANK II`,
  'marketing.scene.rank.c02.lbl09': `RANK III`,
  'marketing.scene.rank.c02.lbl10': `RANK IV`,
  'marketing.scene.rank.n04.lbl01': `FIRST ORDER LIMIT`,
  'marketing.scene.rank.n04.rdo02': `RIGHTS ON ALL ORDERS`,
  'marketing.scene.rank.n04.rdo03': `RIGHTS ON ONLY FIRST ORDER`,
  'marketing.scene.rank.n05.lbl01': `NOTIFY SETTINGS`,
  'marketing.scene.rank.n05.lbl02': `SOURCE OF NOTIFIES`,
  'marketing.scene.rank.n05.chb03': `MESSAGE`,
  'marketing.scene.rank.n05.rdo04': `CHOOSE MESSAGE`,
  'marketing.scene.rank.n05.chb05': `WECHAT MESSAGE`,
  'marketing.scene.rank.n05.rdo06': `CHOOSE MESSAGE`,
  'marketing.scene.rank.n06.lbl01': `NOTIFY RULES`,
  'marketing.scene.rank.n06.rdo02': `ONLY ONE SOURCE`,
  'marketing.scene.rank.c03.lbl01': `PRIORITY OF NOTIFIES`,
  'marketing.scene.rank.c03.lbl02': `SOURCE OF NOTIFIES`,
  'marketing.scene.rank.c03.lbl03': `1`,
  'marketing.scene.rank.c03.lbl04': `WECHAT MESSAGE`,
  'marketing.scene.rank.c03.lbl05': `2`,
  'marketing.scene.rank.c03.lbl06': `MESSAGE`,
  'marketing.scene.rank.n07.rdo01': `ALL SOURCES`,
  'marketing.scene.rank.n07.txt02': `THIS SELECTION MAY BE ANNOYING,PLEASE BE CAUTIOUS BEFORE USING IT.`,
  'marketing.scene.points.n01.lbl01': `BASIC OPTION`,
  'marketing.scene.points.n01.lbl02': `NAME`,
  'marketing.scene.points.n02.lbl01': `RIGHTS AND INTERESTS`,
  'marketing.scene.points.n02.chb02': `RANK RULE`,
  'marketing.scene.points.n02.rdo03': `ALL SAME RULE`,
  'marketing.scene.points.c01.lbl01': `RANK`,
  'marketing.scene.points.c01.lbl02': `DISCOUNT`,
  'marketing.scene.points.c01.lbl03': `POINTS GIVE BACK`,
  'marketing.scene.points.c01.lbl04': `POINTS GIVE AWAY`,
  'marketing.scene.points.c01.lbl05': `VOUCHERS GIVE AWAY`,
  'marketing.scene.points.c01.lbl06': `STATUS`,
  'marketing.scene.points.d01.placeholder01': `PLEASE ENTER VOUCHER NAME`,
  'marketing.scene.points.d01.lbl02': `CHOOSE VOUCHERS`,
  'marketing.scene.points.d01.lbl03': `VOUCHER NAME`,
  'marketing.scene.points.d01.lbl04': `USED FOR`,
  'marketing.scene.points.d01.lbl05': `DETAILS`,
  'marketing.scene.points.d01.lbl06': `PEOPLE LIMITED`,
  'marketing.scene.points.d01.lbl07': `TIMES LIMITED`,
  'marketing.scene.points.d01.lbl08': `REMAINING`,
  'marketing.scene.points.n03.rdo01': `DIFFERENT RULES TO DIFFERENT RANKS`,
  'marketing.scene.points.c02.lbl01': `RANK`,
  'marketing.scene.points.c02.lbl02': `DISCOUNT`,
  'marketing.scene.points.c02.lbl03': `POINTS GIVE BACK`,
  'marketing.scene.points.c02.lbl04': `POINTS GIVE AWAY`,
  'marketing.scene.points.c02.lbl05': `VOUCHERS GIVE AWAY`,
  'marketing.scene.points.c02.lbl06': `STATUS`,
  'marketing.scene.points.c02.lbl07': `RANK I`,
  'marketing.scene.points.c02.lbl08': `RANK II`,
  'marketing.scene.points.c02.lbl09': `RANK III`,
  'marketing.scene.points.c02.lbl10': `RANK IV`,
  'marketing.scene.points.n04.lbl01': `FIRST ORDER LIMIT`,
  'marketing.scene.points.n04.rdo02': `RIGHTS ON ALL ORDERS`,
  'marketing.scene.points.n04.rdo03': `RIGHTS ON ONLY FIRST ORDER`,
  'marketing.scene.points.n05.lbl01': `NOTIFY SETTINGS`,
  'marketing.scene.points.n05.lbl02': `SOURCE OF NOTIFIES`,
  'marketing.scene.points.n05.chb03': `MESSAGE`,
  'marketing.scene.points.n05.rdo04': `CHOOSE MESSAGE`,
  'marketing.scene.points.n05.chb05': `WECHAT MESSAGE`,
  'marketing.scene.points.n05.rdo06': `CHOOSE MESSAGE`,
  'marketing.scene.points.n06.lbl01': `NOTIFY RULES`,
  'marketing.scene.points.n06.rdo02': `ONLY ONE SOURCE`,
  'marketing.scene.points.c03.lbl01': `PRIORITY OF NOTIFIES`,
  'marketing.scene.points.c03.lbl02': `SOURCE OF NOTIFIES`,
  'marketing.scene.points.c03.lbl03': `1`,
  'marketing.scene.points.c03.lbl04': `WECHAT MESSAGE`,
  'marketing.scene.points.c03.lbl05': `2`,
  'marketing.scene.points.c03.lbl06': `MESSAGE`,
  'marketing.scene.points.n07.rdo01': `ALL SOURCES`,
  'marketing.scene.points.n07.txt02': `THIS SELECTION MAY BE ANNOYING,PLEASE BE CAUTIOUS BEFORE USING IT.`,
  'marketing.scene.c01.tip01': `Pause Successfully`, //暂停成功
  'marketing.scene.c01.tip02': `Stop Successfully`, //终止成功
  'marketing.scene.c01.tip03': `Approve Successfully`, //审核成功
  'marketing.scene.c01.tip04': `Restart Successfully`, //重启成功
  'marketing.scene.detail.n01.txt01': `Need to approve`, //待审核
  'marketing.scene.detail.n01.txt02': `Need to start`, //未开始
  'marketing.scene.detail.n01.txt03': `Running`, //进行中
  'marketing.scene.detail.n01.txt04': `Stopped`, //已结束
  'marketing.scene.detail.n01.txt05': `Paused`, //已暂停
  'marketing.people.n01.lbl01': `NOT PURCHASED BUT REGISTRATED`, //注册未支付用户
  'marketing.people.n01.txt02': `NOT PURCHASED BEFORE`, //近七天注册成会员
  'marketing.people.n01.txt03': `REGISTATED IN PAST 7 DAYS`, //但未进行消费的顾客
  'marketing.people.n02.lbl01': `IMPORTANT INACTIVE MEMBERS`, //需重点召回用户
  'marketing.people.n02.txt02': `NOT PURCHASED IN 90DAYS`, //历史下单数和客单价
  'marketing.people.n02.txt03': `BUT HAS HIGHER AMOUNT OF ORDERS AND AVERAGE TRANSACTION VALUE THAN AVG.`, //都高于平均 但近90天未下单
  'marketing.people.n03.lbl01': `CUSTOM`, //自定义人群
  'marketing.people.n03.txt02': `CREATE CUSTOM PLANS`, //根据自身经营情况
  'marketing.people.n03.txt03': `ACCORDING TO STORE SALES.`, //创建个性化的人群运营计划
  'marketing.people.n04.lbl01': `SPECIFIC MP NUMBER`, //指定手机号客户
  'marketing.people.n04.txt02': `POSITIONING MEMBER`, //指定手机号
  'marketing.people.n04.txt03': `BY MP NUMBER.`, //定位精确客户
  'marketing.people.n05.lbl01': `NAME`, //名称
  'marketing.people.n05.rdo02': `TYPE`, //类型
  'marketing.people.n05.rdo03': `STATUS`, //状态
  'marketing.people.c01.lbl01': `MARKETING NAME`, //活动名称
  'marketing.people.c01.lbl02': `TYPE`, //活动类型
  'marketing.people.c01.lbl03': `TIME`, //活动时间
  'marketing.people.c01.lbl04': `PLAN`, //计划方式
  'marketing.people.c01.lbl05': `STATUS`, //状态
  'marketing.people.c01.lbl06': `ACTIONS`, //操作
  'marketing.people.n06.lbl01': `NAME`, //名称
  'marketing.people.n06.lbl02': `TYPE`, //类型
  'marketing.people.n06.lbl03': `STATUS`, //状态
  'marketing.people.d01.txt01': `DO YOU SURE TO PAUSE THIS EVENT?`, //确定要暂停该活动吗?
  'marketing.people.d02.txt01': `DO YOU SURE TO RESTART THIS EVENT?`, //确定要重启该活动吗
  'marketing.people.d03.txt01': `DO YOU SURE TO STOP THIS EVENT?`, //确定要终止该活动吗
  'marketing.people.d04.txt01': `DO YOU SURE TO APPROVE THIS EVENT?`, //确定要通过审核吗？
  'marketing.people.regnotcon.n01.lbl01': `BASIC INFORMATION`,
  'marketing.people.regnotcon.n01.lbl02': `EVENT NAME`,
  'marketing.people.regnotcon.n02.lbl01': `EVENT MEMBERS`,
  'marketing.people.regnotcon.n02.lbl02': `Choose Members`,
  'marketing.people.regnotcon.n02.lbl03': `EVENT NAME MUST BE FILLED IN`, //活动名称为必填项
  'marketing.people.regnotcon.n02.lbl04': `EVENT NAME MUST SHORTER THAN 20 WORDS`, //动名称的最大长度不得大于20
  'marketing.people.regnotcon.n02.lbl05': `EVENT NAME MUST BE FILLED IN`, //活动名称不得为空
  'marketing.people.regnotcon.n02.lbl06': `请使用后缀为".csv"文档`,
  'marketing.people.regnotcon.c01.lbl01': `KIND OF MEMBERS`,
  'marketing.people.regnotcon.c01.lbl02': `AMOUNTS`,
  'marketing.people.regnotcon.n03.lbl01': `CYCLING`,
  'marketing.people.regnotcon.n03.rdo02': `ONCE`,
  'marketing.people.regnotcon.n03.rdo03': `NOW`,
  'marketing.people.regnotcon.n03.rdo04': `PLAN`,
  'marketing.people.regnotcon.n03.rdo05': `PLAN TIME`,
  'marketing.people.regnotcon.n03.placeholder06': `YYYY/MM/DD HH:MM`,
  'marketing.people.regnotcon.n03.rdo07': `CYCLING`,
  'marketing.people.regnotcon.n03.rdo09': `WEEK`, //每月
  'marketing.people.regnotcon.n03.rdo10': `MONTH`, //每月
  'marketing.people.regnotcon.n03.rdo11': `PLAN TIME`, //每月
  'marketing.people.regnotcon.n04.lbl01': `RIGHTS`,
  'marketing.people.regnotcon.n04.lbl02': `VOUCHER SETTINGS`,
  'marketing.people.regnotcon.n04.btn03': `VOUCHER GIVING`,
  'marketing.people.regnotcon.n04.lbl04': `IT'S EFFECTIVE TO GIVING AWAY VOUCHERS.（NO NEED TO TAKE.GIVING AWAY DIRECTLY）`,
  'marketing.people.regnotcon.d01.placeholder01': `PLEASE ENTER VOUCHER NAME`,
  'marketing.people.regnotcon.d01.lbl02': `CHOOSE VOUCHERS`,
  'marketing.people.regnotcon.d01.lbl03': `VOUCHER NAME`,
  'marketing.people.regnotcon.d01.lbl04': `USED FOR`,
  'marketing.people.regnotcon.d01.lbl05': `DETAILS`,
  'marketing.people.regnotcon.d01.lbl06': `PEOPLE LIMITED`,
  'marketing.people.regnotcon.d01.lbl07': `TIMES LIMITED`,
  'marketing.people.regnotcon.d01.lbl08': `REMAINING`,
  'marketing.people.regnotcon.c02.lbl01': `VOUCHER`,
  'marketing.people.regnotcon.c02.lbl02': `VOUCHER DETAILS`,
  'marketing.people.regnotcon.c02.lbl03': `REMAINING`,
  'marketing.people.regnotcon.c02.lbl04': `AMOUNTS OF GIVING AWAY`,
  'marketing.people.regnotcon.c02.lbl05': `ACTION`,
  'marketing.people.regnotcon.n05.lbl01': `NOTIFY SETTINGS`,
  'marketing.people.regnotcon.n05.lbl02': `SOURCE OF NOTIFIES`,
  'marketing.people.regnotcon.n05.chb03': `MESSAGE`,
  'marketing.people.regnotcon.n05.rdo04': `CHOOSE MESSAGE`,
  'marketing.people.regnotcon.n05.chb05': `WECHAT MESSAGE`,
  'marketing.people.regnotcon.n05.rdo06': `CHOOSE MESSAGE`,
  'marketing.people.regnotcon.n06.lbl01': `NOTIFY RULES`,
  'marketing.people.regnotcon.n06.rdo02': `ONLY ONE SOURCE`,
  'marketing.people.regnotcon.c03.lbl01': `PRIORITY OF NOTIFIES`,
  'marketing.people.regnotcon.c03.lbl02': `SOURCE OF NOTIFIES`,
  'marketing.people.regnotcon.c03.lbl03': `1`,
  'marketing.people.regnotcon.c03.lbl04': `WECHAT MESSAGE`,
  'marketing.people.regnotcon.c03.lbl05': `2`,
  'marketing.people.regnotcon.c03.lbl06': `MESSAGE`,
  'marketing.people.regnotcon.n07.rdo01': `ALL SOURCES`,
  'marketing.people.regnotcon.n07.txt02': `THIS SELECTION MAY BE ANNOYING,PLEASE BE CAUTIOUS BEFORE USING IT.`,
  'marketing.people.imprecall.n01.lbl01': `BASIC INFORMATION`,
  'marketing.people.imprecall.n01.lbl02': `EVENT NAME`,
  'marketing.people.imprecall.n02.lbl01': `EVENT MEMBERS`,
  'marketing.people.imprecall.c01.lbl01': `KIND OF MEMBERS`,
  'marketing.people.imprecall.c01.lbl02': `AMOUNTS`,
  'marketing.people.imprecall.n03.lbl01': `CYCLING`,
  'marketing.people.imprecall.n03.rdo02': `ONCE`,
  'marketing.people.imprecall.n03.rdo03': `NOW`,
  'marketing.people.imprecall.n03.rdo04': `PLAN`,
  'marketing.people.imprecall.n03.rdo05': `PLAN TIME`,
  'marketing.people.imprecall.n03.placeholder06': `YYYY/MM/DD HH:MM`,
  'marketing.people.imprecall.n03.rdo07': `CYCLING`,
  'marketing.people.regnotcon.n03.msg01': `请选择活动日期`,
  'marketing.people.regnotcon.n03.msg02': `请选执行时间`,
  'marketing.people.imprecall.n04.lbl01': `RIGHTS`,
  'marketing.people.imprecall.n04.lbl02': `VOUCHER SETTINGS`,
  'marketing.people.imprecall.n04.btn03': `VOUCHER GIVING`,
  'marketing.people.imprecall.n04.lbl04': `IT'S EFFECTIVE TO GIVING AWAY VOUCHERS.（NO NEED TO TAKE.GIVING AWAY DIRECTLY）`,
  'marketing.people.imprecall.d01.placeholder01': `PLEASE ENTER VOUCHER NAME`,
  'marketing.people.imprecall.d01.lbl02': `CHOOSE VOUCHERS`,
  'marketing.people.imprecall.d01.lbl03': `VOUCHER NAME`,
  'marketing.people.imprecall.d01.lbl04': `USED FOR`,
  'marketing.people.imprecall.d01.lbl05': `DETAILS`,
  'marketing.people.imprecall.d01.lbl06': `PEOPLE LIMITED`,
  'marketing.people.imprecall.d01.lbl07': `TIMES LIMITED`,
  'marketing.people.imprecall.d01.lbl08': `REMAINING`,
  'marketing.people.imprecall.c02.lbl01': `VOUCHER`,
  'marketing.people.imprecall.c02.lbl02': `VOUCHER DETAILS`,
  'marketing.people.imprecall.c02.lbl03': `REMAINING`,
  'marketing.people.imprecall.c02.lbl04': `AMOUNTS OF GIVING AWAY`,
  'marketing.people.imprecall.c02.lbl05': `ACTION`,
  'marketing.people.imprecall.n05.lbl01': `NOTIFY SETTINGS`,
  'marketing.people.imprecall.n05.lbl02': `SOURCE OF NOTIFIES`,
  'marketing.people.imprecall.n05.chb03': `MESSAGE`,
  'marketing.people.imprecall.n05.rdo04': `CHOOSE MESSAGE`,
  'marketing.people.imprecall.n05.chb05': `WECHAT MESSAGE`,
  'marketing.people.imprecall.n05.rdo06': `CHOOSE MESSAGE`,
  'marketing.people.imprecall.n06.lbl01': `NOTIFY RULES`,
  'marketing.people.imprecall.n06.rdo02': `ONLY ONE SOURCE`,
  'marketing.people.imprecall.c03.lbl01': `PRIORITY OF NOTIFIES`,
  'marketing.people.imprecall.c03.lbl02': `SOURCE OF NOTIFIES`,
  'marketing.people.imprecall.c03.lbl03': `1`,
  'marketing.people.imprecall.c03.lbl04': `WECHAT MESSAGE`,
  'marketing.people.imprecall.c03.lbl05': `2`,
  'marketing.people.imprecall.c03.lbl06': `MESSAGE`,
  'marketing.people.imprecall.n07.rdo01': `ALL SOURCES`,
  'marketing.people.imprecall.n07.txt02': `THIS SELECTION MAY BE ANNOYING,PLEASE BE CAUTIOUS BEFORE USING IT.`,
  'marketing.people.custom.n01.lbl01': `BASIC INFORMATION`,
  'marketing.people.custom.n01.lbl02': `EVENT NAME`,
  'marketing.people.custom.n01.btn03': `CHOOSE KINDS OF MEMBERS`,
  'marketing.people.custom.n01.lbl04': `EVENT MEMBERS`,
  'marketing.people.custom.d01.lbl01': `CHOOSE KINDS OF MEMBERS`,
  'marketing.people.custom.d01.placeholder02': `PLEASE ENTER NAME OF KIND OF MEMBERS`,
  'marketing.people.custom.d01.lbl03': `NAME OF KIND OF MEMBERS`,
  'marketing.people.custom.d01.lbl04': `AMOUNT`,
  'marketing.people.custom.n02.lbl01': `EVENT MEMBERS`,
  'marketing.people.custom.c01.lbl01': `KIND OF MEMBERS`,
  'marketing.people.custom.c01.lbl02': `AMOUNTS`,
  'marketing.people.custom.n03.lbl01': `CYCLING`,
  'marketing.people.custom.n03.rdo02': `ONCE`,
  'marketing.people.custom.n03.rdo03': `NOW`,
  'marketing.people.custom.n03.rdo04': `PLAN`,
  'marketing.people.custom.n03.rdo05': `PLAN TIME`,
  'marketing.people.custom.n03.placeholder06': `YYYY/MM/DD HH:MM`,
  'marketing.people.custom.n03.rdo07': `CYCLING`,
  'marketing.people.custom.n04.lbl01': `RIGHTS`,
  'marketing.people.custom.n04.lbl02': `VOUCHER SETTINGS`,
  'marketing.people.custom.n04.btn03': `VOUCHER GIVING`,
  'marketing.people.custom.n04.lbl04': `IT'S EFFECTIVE TO GIVING AWAY VOUCHERS.（NO NEED TO TAKE.GIVING AWAY DIRECTLY）`,
  'marketing.people.custom.d02.placeholder01': `PLEASE ENTER VOUCHER NAME`,
  'marketing.people.custom.d02.lbl02': `CHOOSE VOUCHERS`,
  'marketing.people.custom.d02.lbl03': `VOUCHER NAME`,
  'marketing.people.custom.d02.lbl04': `USED FOR`,
  'marketing.people.custom.d02.lbl05': `DETAILS`,
  'marketing.people.custom.d02.lbl06': `PEOPLE LIMITED`,
  'marketing.people.custom.d02.lbl07': `TIMES LIMITED`,
  'marketing.people.custom.d02.lbl08': `REMAINING`,
  'marketing.people.custom.c02.lbl01': `VOUCHER`,
  'marketing.people.custom.c02.lbl02': `VOUCHER DETAILS`,
  'marketing.people.custom.c02.lbl03': `REMAINING`,
  'marketing.people.custom.c02.lbl04': `AMOUNTS OF GIVING AWAY`,
  'marketing.people.custom.c02.lbl05': `ACTION`,
  'marketing.people.custom.n05.lbl01': `NOTIFY SETTINGS`,
  'marketing.people.custom.n05.lbl02': `SOURCE OF NOTIFIES`,
  'marketing.people.custom.n05.chb03': `MESSAGE`,
  'marketing.people.custom.n05.rdo04': `CHOOSE MESSAGE`,
  'marketing.people.custom.n05.chb05': `WECHAT MESSAGE`,
  'marketing.people.custom.n05.rdo06': `CHOOSE MESSAGE`,
  'marketing.people.custom.n06.lbl01': `NOTIFY RULES`,
  'marketing.people.custom.n06.rdo02': `ONLY ONE SOURCE`,
  'marketing.people.custom.c03.lbl01': `PRIORITY OF NOTIFIES`,
  'marketing.people.custom.c03.lbl02': `SOURCE OF NOTIFIES`,
  'marketing.people.custom.c03.lbl03': `1`,
  'marketing.people.custom.c03.lbl04': `WECHAT MESSAGE`,
  'marketing.people.custom.c03.lbl05': `2`,
  'marketing.people.custom.c03.lbl06': `MESSAGE`,
  'marketing.people.custom.n07.rdo01': `ALL SOURCES`,
  'marketing.people.custom.n07.txt02': `THIS SELECTION MAY BE ANNOYING,PLEASE BE CAUTIOUS BEFORE USING IT.`,
  'marketing.people.mpnumber.n01.lbl01': `BASIC INFORMATION`,
  'marketing.people.mpnumber.n01.lbl02': `EVENT NAME`,
  'marketing.people.mpnumber.n01.lbl03': `EVENT MEMBERS`,
  'marketing.people.mpnumber.n01.lbl04': `PLEASE USE DOCUMENT WITH 'CSV' SUFFIX.`,
  'marketing.people.mpnumber.n01.btn05': `IMPORT`,
  'marketing.people.mpnumber.c01.lbl01': `FILE NAME`,
  'marketing.people.mpnumber.c01.lbl02': `SUFFIX`,
  'marketing.people.mpnumber.c01.lbl03': `ACTION`,
  'marketing.people.mpnumber.n03.lbl01': `CYCLING`,
  'marketing.people.mpnumber.n03.rdo02': `ONCE`,
  'marketing.people.mpnumber.n03.rdo03': `NOW`,
  'marketing.people.mpnumber.n03.rdo04': `PLAN`,
  'marketing.people.mpnumber.n03.rdo05': `PLAN TIME`,
  'marketing.people.mpnumber.n03.placeholder06': `YYYY/MM/DD HH:MM`,
  'marketing.people.mpnumber.n03.rdo07': `CYCLING`,
  'marketing.people.mpnumber.n04.lbl01': `RIGHTS`,
  'marketing.people.mpnumber.n04.lbl02': `VOUCHER SETTINGS`,
  'marketing.people.mpnumber.n04.btn03': `VOUCHER GIVING`,
  'marketing.people.mpnumber.n04.lbl04': `IT'S EFFECTIVE TO GIVING AWAY VOUCHERS.（NO NEED TO TAKE.GIVING AWAY DIRECTLY）`,
  'marketing.people.mpnumber.d02.placeholder01': `PLEASE ENTER VOUCHER NAME`,
  'marketing.people.mpnumber.d02.lbl02': `CHOOSE VOUCHERS`,
  'marketing.people.mpnumber.d02.lbl03': `VOUCHER NAME`,
  'marketing.people.mpnumber.d02.lbl04': `USED FOR`,
  'marketing.people.mpnumber.d02.lbl05': `DETAILS`,
  'marketing.people.mpnumber.d02.lbl06': `PEOPLE LIMITED`,
  'marketing.people.mpnumber.d02.lbl07': `TIMES LIMITED`,
  'marketing.people.mpnumber.d02.lbl08': `REMAINING`,
  'marketing.people.mpnumber.c02.lbl01': `VOUCHER`,
  'marketing.people.mpnumber.c02.lbl02': `VOUCHER DETAILS`,
  'marketing.people.mpnumber.c02.lbl03': `REMAINING`,
  'marketing.people.mpnumber.c02.lbl04': `AMOUNTS OF GIVING AWAY`,
  'marketing.people.mpnumber.c02.lbl05': `ACTION`,
  'marketing.people.mpnumber.n05.lbl01': `NOTIFY SETTINGS`,
  'marketing.people.mpnumber.n05.lbl02': `SOURCE OF NOTIFIES`,
  'marketing.people.mpnumber.n05.chb03': `MESSAGE`,
  'marketing.people.mpnumber.n05.rdo04': `CHOOSE MESSAGE`,
  'marketing.people.mpnumber.n05.chb05': `WECHAT MESSAGE`,
  'marketing.people.mpnumber.n05.rdo06': `CHOOSE MESSAGE`,
  'marketing.people.mpnumber.n06.lbl01': `NOTIFY RULES`,
  'marketing.people.mpnumber.n06.rdo02': `ONLY ONE SOURCE`,
  'marketing.people.mpnumber.c03.lbl01': `PRIORITY OF NOTIFIES`,
  'marketing.people.mpnumber.c03.lbl02': `SOURCE OF NOTIFIES`,
  'marketing.people.mpnumber.c03.lbl03': `1`,
  'marketing.people.mpnumber.c03.lbl04': `WECHAT MESSAGE`,
  'marketing.people.mpnumber.c03.lbl05': `2`,
  'marketing.people.mpnumber.c03.lbl06': `MESSAGE`,
  'marketing.people.mpnumber.n07.rdo01': `ALL SOURCES`,
  'marketing.people.mpnumber.n07.txt02': `THIS SELECTION MAY BE ANNOYING,PLEASE BE CAUTIOUS BEFORE USING IT.`,
  'marketing.event.n01.lbl01': `404`,
  'marketing.scene.holiday.c11.lbl01': `STORE CODE`, //门店code
  'marketing.scene.holiday.c11.lbl02': `STORE NAME`, //门店名称
  'marketing.scene.holiday.d03.lbl01': `CHOOSE STORE`, //选择门店
  'marketing.scene.holiday.d03.placeholder02': `PLEASE ENTER STORE NAME`, //请输入门店名称
};
